/*!
 * Copyright (c) 2021 Apple Inc. All rights reserved.
 * Apple Pay JS Software
 *
 * **IMPORTANT:** This Apple Pay JS Software (the "Apple Software") is supplied to you by Apple Inc. ("Apple") in consideration of your agreement to the following terms, and your use, reproduction, or installation of this Apple Software constitutes acceptance of these terms. If you do not agree with these terms, do not use, reproduce or install this Apple Software.
 *
 * This Apple Software is licensed to you solely for: (a) use with the Apple Pay button that you are authorized or legally permitted to embed or display on your website and (b) the purposes set forth above, and may not be used for other purposes or in other contexts without Apple's prior written permission. For the sake of clarity, you may not and agree not to or enable others to, modify or create derivative works of the Apple Software.
 *
 * You may only use the Apple Software if you are a member in good standing of the Apple Developer Program and have accepted the current version of the Apple Developer Program License Agreement. Your use of the Apple Software must conform with the Acceptable Use Guidelines for Apple Pay on the Web, located at https://developer.apple.com/apple-pay/acceptable-use-guidelines-for-websites/, which terms may be updated from time to time.
 *
 * Neither the name, trademarks, service marks or logos of Apple may be used to endorse or promote products or services without specific prior written permission from Apple. Except as expressly stated in this notice, no other rights or licenses, express or implied, are granted by Apple herein.
 *
 * Apple may provide access to services by or through the Apple Software for you to use.  You agree that the services contain proprietary content, information and material that is owned by Apple and its licensors, and is protected by applicable intellectual property and other laws, and that you will not use such proprietary content, information or materials in any way whatsoever except for permitted use of the services or in any manner that is inconsistent with these terms or that infringes any intellectual property rights of a third party or Apple.  Except to the extent expressly permitted in the applicable terms for the services, You agree not to reproduce, modify, rent, lease, lend, sell, distribute, or create derivative works based on the services, in any manner, and you shall not exploit the services in any unauthorized way whatsoever, including but not limited to, using the services to transmit any malware, or by trespass or burdening network capacity.
 *
 * In addition, services that may be accessed, linked to or displayed through the Apple Software may not be available in all languages or in all countries. Apple makes no representation that any such services would be appropriate or available for use in any particular location. Apple reserves the right to change, suspend, remove, or disable access to any services at any time. In no event will Apple be liable for the removal of or disabling of access to any such services or for any updates, maintenance, warranty, technical or other support for such services. Apple may also impose limits or other restrictions on the use of or access to the services, in any case without notice or liability.  You acknowledge and agree that Apple reserves the right to revoke or remove your access to any services provided by or through the Apple Software at any time in its sole discretion.
 *
 * THE APPLE SOFTWARE AND SERVICES ARE PROVIDED BY APPLE ON AN "AS IS" AND "AS AVAILABLE" BASIS. APPLE MAKES NO WARRANTIES, EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION THE IMPLIED WARRANTIES OF NON-INFRINGEMENT, MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE, REGARDING THE APPLE SOFTWARE OR ITS USE AND OPERATION ALONE OR IN COMBINATION WITH YOUR PRODUCTS, SYSTEMS, OR SERVICES.  APPLE DOES NOT WARRANT THAT THE APPLE SOFTWARE AND SERVICES WILL MEET YOUR REQUIREMENTS, THAT THE OPERATION OF THE APPLE SOFTWARE AND SERVICES WILL BE UNINTERRUPTED OR ERROR-FREE, THAT DEFECTS IN THE APPLE  SOFTWARE WILL BE CORRECTED, OR THAT THE APPLE  SOFTWARE AND SERVICES WILL BE COMPATIBLE WITH FUTURE APPLE PRODUCTS, SOFTWARE OR SERVICES. NO ORAL OR WRITTEN INFORMATION OR ADVICE GIVEN BY APPLE OR AN APPLE AUTHORIZED REPRESENTATIVE WILL CREATE A WARRANTY.
 *
 * IN NO EVENT SHALL APPLE BE LIABLE FOR ANY DIRECT, SPECIAL, INDIRECT, INCIDENTAL OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) RELATING TO OR ARISING IN ANY WAY OUT OF THE USE, REPRODUCTION, OR INSTALLATION, OF THE APPLE SOFTWARE AND SERVICES BY YOU OR OTHERS, HOWEVER CAUSED AND WHETHER UNDER THEORY OF CONTRACT, TORT (INCLUDING NEGLIGENCE), STRICT LIABILITY OR OTHERWISE, EVEN IF APPLE HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE. SOME JURISDICTIONS DO NOT ALLOW THE LIMITATION OF LIABILITY FOR PERSONAL INJURY, OR OF INCIDENTAL OR CONSEQUENTIAL DAMAGES, SO THIS LIMITATION MAY NOT APPLY TO YOU. In no event shall Appleâ€™s total liability to you for all damages (other than as may be required by applicable law in cases involving personal injury) exceed the amount of fifty dollars ($50.00). The foregoing limitations will apply even if the above stated remedy fails of its essential purpose.
 *
 * **ACKNOWLEDGEMENTS:**
 * https://applepay.cdn-apple.com/jsapi/v1/acknowledgements.txt
 *
 * 6.3.2021
 */ !(function (t) {
  function e(e) {
    for (var n, a, o = e[0], i = e[1], s = 0, l = []; s < o.length; s++)
      (a = o[s]), Object.prototype.hasOwnProperty.call(r, a) && r[a] && l.push(r[a][0]), (r[a] = 0);
    for (n in i) Object.prototype.hasOwnProperty.call(i, n) && (t[n] = i[n]);
    for (h && h(e); l.length; ) l.shift()();
  }
  var n = {},
    r = { 0: 0 };
  function a(e) {
    if (n[e]) return n[e].exports;
    var r = (n[e] = { i: e, l: !1, exports: {} });
    return t[e].call(r.exports, r, r.exports, a), (r.l = !0), r.exports;
  }
  (a.e = function (t) {
    var e = [],
      n = r[t];
    if (0 !== n)
      if (n) e.push(n[2]);
      else {
        var o = new Promise(function (e, a) {
          n = r[t] = [e, a];
        });
        e.push((n[2] = o));
        var i,
          s = document.createElement('script');
        (s.charset = 'utf-8'),
          (s.timeout = 120),
          a.nc && s.setAttribute('nonce', a.nc),
          (s.src = (function (t) {
            return a.p + '' + { 2: '80356488c7096b9e0b8b' }[t] + '.apple-pay-sdk.js';
          })(t));
        var h = new Error();
        i = function (e) {
          (s.onerror = s.onload = null), clearTimeout(l);
          var n = r[t];
          if (0 !== n) {
            if (n) {
              var a = e && ('load' === e.type ? 'missing' : e.type),
                o = e && e.target && e.target.src;
              (h.message = 'Loading chunk ' + t + ' failed.\n(' + a + ': ' + o + ')'),
                (h.name = 'ChunkLoadError'),
                (h.type = a),
                (h.request = o),
                n[1](h);
            }
            r[t] = void 0;
          }
        };
        var l = setTimeout(function () {
          i({ type: 'timeout', target: s });
        }, 12e4);
        (s.onerror = s.onload = i), document.head.appendChild(s);
      }
    return Promise.all(e);
  }),
    (a.m = t),
    (a.c = n),
    (a.d = function (t, e, n) {
      a.o(t, e) || Object.defineProperty(t, e, { enumerable: !0, get: n });
    }),
    (a.r = function (t) {
      'undefined' != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, { value: 'Module' }),
        Object.defineProperty(t, '__esModule', { value: !0 });
    }),
    (a.t = function (t, e) {
      if ((1 & e && (t = a(t)), 8 & e)) return t;
      if (4 & e && 'object' == typeof t && t && t.__esModule) return t;
      var n = Object.create(null);
      if ((a.r(n), Object.defineProperty(n, 'default', { enumerable: !0, value: t }), 2 & e && 'string' != typeof t))
        for (var r in t)
          a.d(
            n,
            r,
            function (e) {
              return t[e];
            }.bind(null, r)
          );
      return n;
    }),
    (a.n = function (t) {
      var e =
        t && t.__esModule
          ? function () {
              return t.default;
            }
          : function () {
              return t;
            };
      return a.d(e, 'a', e), e;
    }),
    (a.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }),
    (a.p = ''),
    (a.oe = function (t) {
      throw (console.error(t), t);
    });
  var o = (window.webpackJsonp = window.webpackJsonp || []),
    i = o.push.bind(o);
  (o.push = e), (o = o.slice());
  for (var s = 0; s < o.length; s++) e(o[s]);
  var h = i;
  a((a.s = 103));
})({
  103: function (t, e, n) {
    'use strict';
    n.r(e),
      function (t) {
        var e = n(14);
        function r(t, e, n, r, a, o, i) {
          try {
            var s = t[o](i),
              h = s.value;
          } catch (t) {
            return void n(t);
          }
          s.done ? e(h) : Promise.resolve(h).then(r, a);
        }
        function a() {
          var a = [
            'ar-AB',
            'ca-ES',
            'cs-CZ',
            'da-DK',
            'de-DE',
            'el-GR',
            'en-US',
            'en-AU',
            'en-GB',
            'es-ES',
            'es-MX',
            'fi-FI',
            'fr-CA',
            'fr-FR',
            'he-IL',
            'hi-IN',
            'hr-HR',
            'hu-HU',
            'id-ID',
            'it-IT',
            'ja-JP',
            'ko-KR',
            'ms-MY',
            'nb-NO',
            'nl-NL',
            'pl-PL',
            'pt-BR',
            'pt-PT',
            'ro-RO',
            'ru-RU',
            'sk-SK',
            'sv-SE',
            'th-TH',
            'tr-TR',
            'uk-UA',
            'vi-VN',
            'zh-CN',
            'zh-HK',
            'zh-TW',
          ];
          function o(t) {
            return (null == t ? void 0 : t.includes('-')) && !!a.find((e) => e === t);
          }
          function i(t) {
            if (t) {
              var e = t.trim().replace('_', '-').split('-'),
                n = e[0].toLowerCase();
              return 1 === e.length ? n : n + '-' + e[1].toUpperCase();
            }
          }
          function s(t) {
            var e = ((void 0 === navigator.languages ? [navigator.language] : navigator.languages) || []).map(i),
              n = null == t ? void 0 : t.closest('[lang]'),
              r = (null == n ? void 0 : n.lang) ? i(n.lang) : void 0;
            return r && e.unshift(r), e;
          }
          function h(t, e = !0) {
            var n = null == t ? void 0 : t.includes('-');
            if (n) {
              var r = a.find((e) => e === t);
              if (r) return r;
            }
            if (t && (!n || e)) {
              var o = (function (t) {
                var e = null == t ? void 0 : t.split('-')[0];
                return a.find((t) => new RegExp('^'.concat(e), 'g').test(t));
              })(t);
              if (o) return o;
            }
          }
          function l(t) {
            var e = s(t).reduce((t, e) => {
              if (t && t.includes('-')) return t;
              if (!t) {
                if (o(e)) return e;
                var n = (function (t) {
                  var e = null == t ? void 0 : t.split('-')[0];
                  return e && a.find((t) => t.startsWith(e)) ? e : void 0;
                })(e);
                if (n) return n;
              }
              return t && !t.includes('-') && e.startsWith(t) && o(e) ? e : t;
            }, void 0);
            return ((null == e ? void 0 : e.includes('-')) ? e : h(e)) || 'en-US';
          }
          function c() {
            try {
              return document.fonts.check('15px -apple-system');
            } catch (t) {
              return !1;
            }
          }
          function d(t) {
            return !!document.getElementById(u(t));
          }
          function w(t) {
            var e = document.createElement('style');
            (e.id = u(t)),
              (e.innerHTML =
                '@font-face{' +
                'font-family:apple-pay-btn-'.concat(t, ';') +
                'src:url('.concat(p('./assets/1.0.0/fonts/'.concat(t, '.woff2')), ') format("woff2"),') +
                'url('.concat(p('./assets/1.0.0/fonts/'.concat(t, '.woff')), ') format("woff");') +
                'font-display:block;}'),
              document.head.appendChild(e);
          }
          function u(t) {
            return 'apple-pay-btn-font-'.concat(t);
          }
          function p(t) {
            return n.p + t.replace(/^\.\//, '/');
          }
          var $ = [
            'add-money',
            'book',
            'buy',
            'check-out',
            'continue',
            'contribute',
            'donate',
            'order',
            'pay',
            'plain',
            'reload',
            'rent',
            'set-up',
            'subscribe',
            'support',
            'tip',
            'top-up',
          ];
          function f(t) {
            return $.includes(t);
          }
          function m(t) {
            switch (t) {
              case 'add-money':
                return 'a';
              case 'book':
                return 'bo';
              case 'buy':
                return 'bu';
              case 'check-out':
                return 'ch';
              case 'continue':
                return 'ci';
              case 'contribute':
                return 'co';
              case 'donate':
                return 'd';
              case 'order':
                return 'o';
              case 'pay':
                return 'pa';
              case 'plain':
                return 'p';
              case 'reload':
                return 'rl';
              case 'rent':
                return 'rn';
              case 'set-up':
                return 'se';
              case 'subscribe':
                return 'sb';
              case 'support':
                return 'sp';
              case 'tip':
                return 'ti';
              case 'top-up':
                return 'to';
            }
          }
          function g(t, e) {
            var n = [...t.l[m(e)]],
              r = n[0].t.startsWith('%@') ? 0 : 1;
            return (
              (n = n.map((t) => Object.assign(Object.assign({}, t), { t: t.t.replace(/%@/g, '') }))).splice(r, 0, { t: '%@' }),
              t.rtl && n.reverse(),
              n
            );
          }
          function b(t, e) {
            if ('plain' === e) return 'Apple Pay';
            var n = g(t, e);
            return t.rtl && n.reverse(), n.reduce((t, e) => t + ('%@' === e.t ? 'Apple Pay' : e.t), '');
          }
          function v(t, e, n, r, a) {
            var o = e.t.replace(/\s/g, '&#160;');
            return (
              '<text x="'.concat(t, '" y="').concat(
                (function (t) {
                  switch (t) {
                    case 'ja-JP':
                      return 20;
                    case 'ko-KR':
                      return 19.6;
                  }
                  return 19.5;
                })(r),
                '" '
              ) +
              ''.concat(n ? 'direction="rtl" unicode-bidi="bidi-override" text-anchor="end"' : '', ' ') +
              ''.concat(a ? 'style="letter-spacing:'.concat(a, ';"') : '', ' ') +
              ''.concat(
                (function (t) {
                  return 'hi-IN' !== t && 'th-TH' !== t;
                })(r)
                  ? 'height="'
                      .concat(e.h, '" width="')
                      .concat(e.w, '" ')
                      .concat(n ? '' : 'textLength="'.concat(e.w, '"'))
                  : '',
                '>'
              ) +
              ''.concat(o, '</text>')
            );
          }
          function y(t, e, n, r, a) {
            var o =
              '<?xml version="1.0" encoding="UTF-8"?>\n<svg class="logo" viewBox="0 0 105 43" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n    <title>Apple Logo</title>\n    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n        <g fill="#FFF">\n            <path d="M19.4028,5.5674 C20.6008,4.0684 21.4138,2.0564 21.1998,0.0004 C19.4458,0.0874 17.3058,1.1574 16.0668,2.6564 C14.9538,3.9414 13.9688,6.0374 14.2258,8.0074 C16.1948,8.1784 18.1618,7.0244 19.4028,5.5674"></path>\n            <path d="M21.1772,8.3926 C18.3182,8.2226 15.8872,10.0156 14.5212,10.0156 C13.1552,10.0156 11.0642,8.4786 8.8022,8.5196 C5.8592,8.5626 3.1282,10.2276 1.6342,12.8746 C-1.4378,18.1696 0.8232,26.0246 3.8112,30.3376 C5.2622,32.4716 7.0102,34.8206 9.3142,34.7366 C11.4912,34.6506 12.3442,33.3266 14.9902,33.3266 C17.6352,33.3266 18.4042,34.7366 20.7082,34.6936 C23.0972,34.6506 24.5922,32.5586 26.0422,30.4226 C27.7072,27.9906 28.3882,25.6426 28.4312,25.5126 C28.3882,25.4706 23.8232,23.7186 23.7812,18.4676 C23.7382,14.0706 27.3652,11.9786 27.5362,11.8496 C25.4882,8.8196 22.2872,8.4786 21.1772,8.3926"></path>\n            <path d="M85.5508,43.0381 L85.5508,39.1991 C85.8628,39.2421 86.6158,39.2871 87.0158,39.2871 C89.2138,39.2871 90.4558,38.3551 91.2108,35.9581 L91.6548,34.5371 L83.2428,11.2321 L88.4368,11.2321 L94.2958,30.1421 L94.4068,30.1421 L100.2668,11.2321 L105.3278,11.2321 L96.6048,35.7141 C94.6078,41.3291 92.3208,43.1721 87.4828,43.1721 C87.1048,43.1721 85.8838,43.1271 85.5508,43.0381"></path>\n            <path d="M42.6499,19.3555 L48.3549,19.3555 C52.6829,19.3555 55.1469,17.0255 55.1469,12.9855 C55.1469,8.9455 52.6829,6.6375 48.3769,6.6375 L42.6499,6.6375 L42.6499,19.3555 Z M49.6869,2.4425 C55.9009,2.4425 60.2289,6.7265 60.2289,12.9625 C60.2289,19.2225 55.8129,23.5285 49.5309,23.5285 L42.6499,23.5285 L42.6499,34.4705 L37.6779,34.4705 L37.6779,2.4425 L49.6869,2.4425 Z"></path>\n            <path d="M76.5547,25.7705 L76.5547,23.9715 L71.0287,24.3275 C67.9207,24.5275 66.3007,25.6815 66.3007,27.7015 C66.3007,29.6545 67.9887,30.9195 70.6287,30.9195 C74.0027,30.9195 76.5547,28.7665 76.5547,25.7705 M61.4617,27.8345 C61.4617,23.7285 64.5917,21.3755 70.3627,21.0205 L76.5547,20.6425 L76.5547,18.8675 C76.5547,16.2705 74.8457,14.8495 71.8057,14.8495 C69.2967,14.8495 67.4777,16.1375 67.0997,18.1125 L62.6167,18.1125 C62.7497,13.9615 66.6567,10.9435 71.9387,10.9435 C77.6207,10.9435 81.3267,13.9175 81.3267,18.5345 L81.3267,34.4705 L76.7327,34.4705 L76.7327,30.6305 L76.6217,30.6305 C75.3127,33.1395 72.4267,34.7145 69.2967,34.7145 C64.6807,34.7145 61.4617,31.9625 61.4617,27.8345"></path>\n        </g>\n    </g>\n</svg>'.replace(
                '<svg',
                '<svg '
                  .concat(a ? 'id="'.concat(a, '"') : '', ' x="')
                  .concat(t, '" y="')
                  .concat(e, '" height="')
                  .concat(n, '" width="')
                  .concat(35, '"')
              );
            return 'black' !== r && (o = o.replace('fill="#FFF"', 'fill="#000"')), o;
          }
          function x(t) {
            var e = g(t.metadata, t.buttonType),
              n = t.metadata.ls,
              { width: r, domStr: a } = e.reduce(
                (r, a, o) => {
                  var i;
                  if ('%@' === a.t) {
                    o > 0 && new RegExp(/\s$/).test(r.prev) && (r.width = r.width + 1);
                    var s = 0 === o || o === e.length - 1;
                    return {
                      domStr: r.domStr + y(r.width + 0.2, 7.92, 15, t.buttonStyle),
                      width: r.width + 35 + (s ? 0.2 : 0.4),
                      prev: a.t,
                    };
                  }
                  return (
                    '%@' === r.prev && (null === (i = a.t) || void 0 === i ? void 0 : i.startsWith(' '))
                      ? (r.width = r.width + 1)
                      : '%@' === r.prev && (r.width = r.width + 0.2),
                    { domStr: r.domStr + v(r.width, a, !!t.metadata.rtl, t.locale, n), width: r.width + a.w, prev: a.t }
                  );
                },
                { width: 12.5, domStr: '', prev: '' }
              );
            return { width: r + 12.5, domStr: a };
          }
          function k(t, e = !1) {
            return '<svg id="svg-logo" viewBox="0 0 '
              .concat(35, ' ')
              .concat(15, '" ')
              .concat(e ? 'class="hidden"' : '', '>\n  ')
              .concat(y(0, 3.85, 7.3, t, 'svg-logo'), '\n  </svg>');
          }
          function S(t) {
            if ('plain' === t.buttonType) return k(t.buttonStyle, !1);
            var { width: e, domStr: n } = x(t),
              r = c();
            return '<svg id="svg-text" viewBox="0 0 '
              .concat(e, ' 28.571" aria-hidden="true">\n    <defs>\n      <style>\n        text {\n          fill: ')
              .concat('black' === t.buttonStyle ? '#FFF' : '#000', ';\n          font-family: ')
              .concat(r ? '-apple-system' : 'apple-pay-btn-'.concat(t.locale), ';\n          font-size: ')
              .concat(t.metadata.s, ';\n          font-weight: ')
              .concat(t.metadata.w || 500, ';\n        }\n      </style>\n    </defs>\n    <g>\n      ')
              .concat(n, '\n    </g>\n  </svg>\n  ')
              .concat(k(t.buttonStyle, !0));
          }
          var C = {
              'en-US': {
                l: {
                  a: [{ w: 110.86, h: 18, t: 'Add Money with %@' }],
                  bo: [{ w: 68.8, h: 18, t: 'Book with %@' }],
                  bu: [{ w: 60.39, h: 18, t: 'Buy with %@' }],
                  ch: [{ w: 102.89, h: 18, t: 'Check out with %@' }],
                  ci: [{ w: 95.58, h: 18, t: 'Continue with %@' }],
                  co: [{ w: 105.94, h: 18, t: 'Contribute with %@' }],
                  d: [{ w: 83, h: 18, t: 'Donate with %@' }],
                  o: [{ w: 72.86, h: 18, t: 'Order with %@' }],
                  pa: [{ w: 59, h: 18, t: 'Pay with %@' }],
                  rl: [{ w: 80.89, h: 18, t: 'Reload with %@' }],
                  rn: [{ w: 65.67, h: 18, t: 'Rent with %@' }],
                  se: [{ w: 45.88, h: 18, t: 'Set up %@' }],
                  sb: [{ w: 102.14, h: 18, t: 'Subscribe with %@' }],
                  sp: [{ w: 88.67, h: 18, t: 'Support with %@' }],
                  ti: [{ w: 55.58, h: 18, t: 'Tip with %@' }],
                  to: [{ w: 81.66, h: 18, t: 'Top Up with %@' }],
                },
                s: '15px',
                ls: '0.22px',
              },
              'fr-FR': {
                l: {
                  a: [{ w: 159.45, h: 18, t: 'Ajouter de lâ€™argent avec %@' }],
                  bo: [{ w: 96.92, h: 18, t: 'RÃ©server avec %@' }],
                  bu: [{ w: 90.47, h: 18, t: 'Acheter avec %@' }],
                  ch: [{ w: 75.22, h: 18, t: 'Payer avec %@' }],
                  ci: [{ w: 108.56, h: 18, t: 'Poursuivre avec %@' }],
                  co: [{ w: 109.41, h: 18, t: 'Contribuer avec %@' }],
                  d: [{ w: 118.92, h: 18, t: 'Faire un don avec %@' }],
                  o: [{ w: 120.53, h: 18, t: 'Commander avec %@' }],
                  pa: [{ w: 75.22, h: 18, t: 'Payer avec %@' }],
                  rl: [{ w: 106.7, h: 18, t: 'Recharger avec %@' }],
                  rn: [{ w: 75.95, h: 18, t: 'Louer avec %@' }],
                  se: [{ w: 74.19, h: 18, t: 'Configurer %@' }],
                  sb: [{ w: 105.61, h: 18, t: 'Sâ€™abonner avec %@' }],
                  sp: [{ w: 93.98, h: 18, t: 'Soutenir avec %@' }],
                  ti: [{ w: 173.25, h: 18, t: 'Laisser un pourboire avec %@' }],
                  to: [{ w: 106.7, h: 18, t: 'Recharger avec %@' }],
                },
                s: '15px',
                ls: '0.22px',
              },
              'el-GR': {
                l: {
                  a: [{ w: 190.19, h: 18, t: 'Î ÏÎ¿ÏƒÎ¸Î®ÎºÎ· Ï‡ÏÎ·Î¼Î¬Ï„Ï‰Î½ Î¼Î­ÏƒÏ‰ %@' }],
                  bo: [{ w: 106, h: 18, t: 'ÎšÏÎ¬Ï„Î·ÏƒÎ· Î¼Î­ÏƒÏ‰ %@' }],
                  bu: [{ w: 87.64, h: 18, t: 'Î‘Î³Î¿ÏÎ¬ Î¼Î­ÏƒÏ‰ %@' }],
                  ch: [{ w: 109.66, h: 18, t: 'Î Î»Î·ÏÏ‰Î¼Î® Î¼Î­ÏƒÏ‰ %@' }],
                  ci: [
                    { w: 95.81, h: 18, t: 'Î£Ï…Î½Î­Ï‡ÎµÎ¹Î± Î¼Îµ Â«' },
                    { w: 9.42, h: 18, t: 'Â»' },
                  ],
                  co: [{ w: 127.23, h: 18, t: 'Î£Ï…Î½ÎµÎ¹ÏƒÏ†Î¿ÏÎ¬ Î¼Î­ÏƒÏ‰ %@' }],
                  d: [{ w: 90.83, h: 18, t: 'Î”Ï‰ÏÎµÎ¬ Î¼Î­ÏƒÏ‰ %@' }],
                  o: [{ w: 127.36, h: 18, t: 'Î Î±ÏÎ±Î³Î³ÎµÎ»Î¯Î± Î¼Î­ÏƒÏ‰ %@' }],
                  pa: [{ w: 89.17, h: 18, t: 'Î Î»Î·ÏÏ‰Î¼Î® Î¼Îµ %@' }],
                  rl: [{ w: 153.41, h: 18, t: 'Î•Ï€Î±Î½Î±Ï†ÏŒÏÏ„Ï‰ÏƒÎ· Î¼Î­ÏƒÏ‰ %@' }],
                  rn: [{ w: 113.61, h: 18, t: 'Î•Î½Î¿Î¹ÎºÎ¯Î±ÏƒÎ· Î¼Î­ÏƒÏ‰ %@' }],
                  se: [{ w: 92.92, h: 18, t: 'Î”Î¹Î±Î¼ÏŒÏÏ†Ï‰ÏƒÎ· %@' }],
                  sb: [{ w: 112.38, h: 18, t: 'Î£Ï…Î½Î´ÏÎ¿Î¼Î® Î¼Î­ÏƒÏ‰ %@' }],
                  sp: [{ w: 126.31, h: 18, t: 'Î¥Ï€Î¿ÏƒÏ„Î®ÏÎ¹Î¾Î· Î¼Î­ÏƒÏ‰ %@' }],
                  ti: [{ w: 132.8, h: 18, t: 'Î¦Î¹Î»Î¿Î´ÏŽÏÎ·Î¼Î± Î¼Î­ÏƒÏ‰ %@' }],
                  to: [{ w: 116.41, h: 18, t: 'Î‘Î½Î±Î½Î­Ï‰ÏƒÎ· Î¼Î­ÏƒÏ‰ %@' }],
                },
                s: '15px',
                ls: '0.22px',
              },
              'zh-HK': {
                l: {
                  a: [
                    { w: 17.81, h: 18, t: 'ç”¨ ' },
                    { w: 32.61, h: 18, t: ' å¢žå€¼' },
                  ],
                  bo: [
                    { w: 17.81, h: 18, t: 'ç”¨ ' },
                    { w: 32.61, h: 18, t: ' è¨‚ä½' },
                  ],
                  bu: [
                    { w: 17.81, h: 18, t: 'ç”¨ ' },
                    { w: 32.61, h: 18, t: ' è³¼è²·' },
                  ],
                  ch: [
                    { w: 17.81, h: 18, t: 'ç”¨ ' },
                    { w: 32.61, h: 18, t: ' çµå¸³' },
                  ],
                  ci: [
                    { w: 32.61, h: 18, t: 'ä½¿ç”¨ ' },
                    { w: 32.61, h: 18, t: ' ç¹¼çºŒ' },
                  ],
                  co: [
                    { w: 17.81, h: 18, t: 'ç”¨ ' },
                    { w: 32.61, h: 18, t: ' æè´ˆ' },
                  ],
                  d: [
                    { w: 17.81, h: 18, t: 'ç”¨ ' },
                    { w: 32.61, h: 18, t: ' ææ¬¾' },
                  ],
                  o: [
                    { w: 17.81, h: 18, t: 'ç”¨ ' },
                    { w: 32.61, h: 18, t: ' è¨‚è³¼' },
                  ],
                  pa: [
                    { w: 17.81, h: 18, t: 'ç”¨ ' },
                    { w: 32.61, h: 18, t: ' ä»˜æ¬¾' },
                  ],
                  rl: [
                    { w: 17.81, h: 18, t: 'ç”¨ ' },
                    { w: 32.61, h: 18, t: ' å¢žå€¼' },
                  ],
                  rn: [
                    { w: 17.81, h: 18, t: 'ç”¨ ' },
                    { w: 32.61, h: 18, t: ' ç§Ÿå€Ÿ' },
                  ],
                  se: [{ w: 32.61, h: 18, t: 'è¨­å®š %@' }],
                  sb: [
                    { w: 17.81, h: 18, t: 'ç”¨ ' },
                    { w: 32.61, h: 18, t: ' è¨‚é–²' },
                  ],
                  sp: [
                    { w: 17.81, h: 18, t: 'ç”¨ ' },
                    { w: 32.61, h: 18, t: ' æ”¯æŒ' },
                  ],
                  ti: [
                    { w: 17.81, h: 18, t: 'ç”¨ ' },
                    { w: 62.2, h: 18, t: ' æ”¯ä»˜è²¼å£«' },
                  ],
                  to: [
                    { w: 17.81, h: 18, t: 'ç”¨ ' },
                    { w: 32.61, h: 18, t: ' å¢žå€¼' },
                  ],
                },
                s: '14.8px',
              },
              'zh-CN': {
                l: {
                  a: [
                    { w: 17.81, h: 18, t: 'ç”¨ ' },
                    { w: 32.61, h: 18, t: ' å……å€¼' },
                  ],
                  bo: [
                    { w: 17.81, h: 18, t: 'ç”¨ ' },
                    { w: 32.61, h: 18, t: ' é¢„è®¢' },
                  ],
                  bu: [
                    { w: 17.81, h: 18, t: 'ç”¨ ' },
                    { w: 32.61, h: 18, t: ' è´­ä¹°' },
                  ],
                  ch: [
                    { w: 17.81, h: 18, t: 'ç”¨ ' },
                    { w: 32.61, h: 18, t: ' ç»“è´¦' },
                  ],
                  ci: [
                    { w: 32.61, h: 18, t: 'é€šè¿‡ ' },
                    { w: 32.61, h: 18, t: ' ç»§ç»­' },
                  ],
                  co: [
                    { w: 17.81, h: 18, t: 'ç”¨ ' },
                    { w: 32.61, h: 18, t: ' æèµ ' },
                  ],
                  d: [
                    { w: 17.81, h: 18, t: 'ç”¨ ' },
                    { w: 32.61, h: 18, t: ' ææ¬¾' },
                  ],
                  o: [
                    { w: 17.81, h: 18, t: 'ç”¨ ' },
                    { w: 32.61, h: 18, t: ' è®¢è´­' },
                  ],
                  pa: [
                    { w: 17.81, h: 18, t: 'ç”¨ ' },
                    { w: 32.61, h: 18, t: ' æ”¯ä»˜' },
                  ],
                  rl: [
                    { w: 17.81, h: 18, t: 'ç”¨ ' },
                    { w: 32.61, h: 18, t: ' å……å€¼' },
                  ],
                  rn: [
                    { w: 17.81, h: 18, t: 'ç”¨ ' },
                    { w: 32.61, h: 18, t: ' ç§Ÿå€Ÿ' },
                  ],
                  se: [{ w: 32.61, h: 18, t: 'è®¾ç½® %@' }],
                  sb: [
                    { w: 17.81, h: 18, t: 'ç”¨ ' },
                    { w: 32.61, h: 18, t: ' è®¢é˜…' },
                  ],
                  sp: [
                    { w: 17.81, h: 18, t: 'ç”¨ ' },
                    { w: 32.61, h: 18, t: ' æ”¯æŒ' },
                  ],
                  ti: [
                    { w: 17.81, h: 18, t: 'ç”¨ ' },
                    { w: 47.41, h: 18, t: ' ä»˜å°è´¹' },
                  ],
                  to: [
                    { w: 17.81, h: 18, t: 'ç”¨ ' },
                    { w: 32.61, h: 18, t: ' å……å€¼' },
                  ],
                },
                s: '14.8px',
              },
              'pt-BR': {
                l: {
                  a: [{ w: 152.69, h: 18, t: 'Adicione Dinheiro com %@' }],
                  bo: [{ w: 94.23, h: 18, t: 'Reservar com %@' }],
                  bu: [{ w: 93.73, h: 18, t: 'Comprar com %@' }],
                  ch: [{ w: 73.58, h: 18, t: 'Pagar com %@' }],
                  ci: [{ w: 101.13, h: 18, t: 'Continuar com %@' }],
                  co: [{ w: 101.52, h: 18, t: 'Contribua com %@' }],
                  d: [{ w: 67.33, h: 18, t: 'Doar com %@' }],
                  o: [{ w: 119.66, h: 18, t: 'Encomendar com %@' }],
                  pa: [{ w: 73.58, h: 18, t: 'Pagar com %@' }],
                  rl: [{ w: 108.69, h: 18, t: 'Recarregar com %@' }],
                  rn: [{ w: 78.98, h: 18, t: 'Alugar com %@' }],
                  se: [{ w: 74.22, h: 18, t: 'Configurar %@' }],
                  sb: [{ w: 85.17, h: 18, t: 'Assinar com %@' }],
                  sp: [{ w: 78.98, h: 18, t: 'Apoiar com %@' }],
                  ti: [{ w: 108.94, h: 18, t: 'Dar gorjeta com %@' }],
                  to: [{ w: 108.69, h: 18, t: 'Recarregar com %@' }],
                },
                s: '15px',
                ls: '0.22px',
              },
              'en-AU': {
                l: {
                  a: [{ w: 110.86, h: 18, t: 'Add Money with %@' }],
                  bo: [{ w: 68.8, h: 18, t: 'Book with %@' }],
                  bu: [{ w: 60.39, h: 18, t: 'Buy with %@' }],
                  ch: [{ w: 102.89, h: 18, t: 'Check out with %@' }],
                  ci: [{ w: 95.58, h: 18, t: 'Continue with %@' }],
                  co: [{ w: 105.94, h: 18, t: 'Contribute with %@' }],
                  d: [{ w: 83, h: 18, t: 'Donate with %@' }],
                  o: [{ w: 72.86, h: 18, t: 'Order with %@' }],
                  pa: [{ w: 59, h: 18, t: 'Pay with %@' }],
                  rl: [{ w: 80.89, h: 18, t: 'Reload with %@' }],
                  rn: [{ w: 65.67, h: 18, t: 'Rent with %@' }],
                  se: [{ w: 45.88, h: 18, t: 'Set up %@' }],
                  sb: [{ w: 102.14, h: 18, t: 'Subscribe with %@' }],
                  sp: [{ w: 88.67, h: 18, t: 'Support with %@' }],
                  ti: [{ w: 55.58, h: 18, t: 'Tip with %@' }],
                  to: [{ w: 81.66, h: 18, t: 'Top Up with %@' }],
                },
                s: '15px',
                ls: '0.22px',
              },
              'he-IL': {
                l: {
                  a: [{ w: 148.58, h: 17.22, t: '×œ×”×•×¡×™×£ ×›×¡×£ ×‘××ž×¦×¢×•×ª %@' }],
                  bo: [{ w: 111.2, h: 17.22, t: '×”×–×ž×Ÿ/×™ ×‘××ž×¦×¢×•×ª %@' }],
                  bu: [{ w: 112.61, h: 17, t: '×¨×›×™×©×” ×‘××ž×¦×¢×•×ª %@' }],
                  ch: [{ w: 68.77, h: 17.22, t: '×œ×§×•×¤×” ×¢× %@' }],
                  ci: [{ w: 77.39, h: 17.22, t: '×”×ž×©×š/×™ ×¢× %@' }],
                  co: [{ w: 63.39, h: 17.22, t: '×œ×˜×¢×•×Ÿ ×¢× %@' }],
                  d: [{ w: 70.98, h: 17, t: '×ª×¨×•×/×™ ×¢× %@' }],
                  o: [{ w: 113.98, h: 17.22, t: '×œ×”×–×ž×™×Ÿ ×‘××ž×¦×¢×•×ª %@' }],
                  pa: [{ w: 109.45, h: 17, t: '×©×œ×/×™ ×‘××ž×¦×¢×•×ª %@' }],
                  rl: [{ w: 106.09, h: 17.22, t: '×œ×˜×¢×•×Ÿ ×‘××ž×¦×¢×•×ª %@' }],
                  rn: [{ w: 110.7, h: 17, t: '×œ×©×›×•×¨ ×‘××ž×¦×¢×•×ª %@' }],
                  se: [{ w: 76.44, h: 17, t: '×œ×”×’×“×™×¨ ××ª %@' }],
                  sb: [{ w: 108.44, h: 17, t: '×¨×™×©×•× ×›×ž×™× ×•×™ ×¢× %@' }],
                  sp: [{ w: 112.34, h: 17.22, t: '×œ×ª×ž×•×š ×‘××ž×¦×¢×•×ª %@' }],
                  ti: [{ w: 150.63, h: 17, t: '×œ×”×©××™×¨ ×˜×™×¤ ×‘××ž×¦×¢×•×ª %@' }],
                  to: [{ w: 106, h: 17, t: '×œ×ž×œ× ×‘××ž×¦×¢×•×ª %@' }],
                },
                s: '14px',
                rtl: !0,
                w: 700,
              },
              'ar-AB': {
                l: {
                  a: [{ w: 99.73, h: 15, t: 'Ø¥Ø¶Ø§ÙØ© Ù…Ø§Ù„ Ø¨Ø§Ø³ØªØ®Ø¯Ø§Ù… %@' }],
                  bo: [{ w: 72.73, h: 15, t: 'Ø­Ø¬Ø² Ø¨Ø§Ø³ØªØ®Ø¯Ø§Ù… %@' }],
                  bu: [{ w: 74.05, h: 15, t: 'Ø´Ø±Ø§Ø¡ Ø¨Ø§Ø³ØªØ®Ø¯Ø§Ù… %@' }],
                  ch: [{ w: 111.41, h: 15, t: 'Ø¯ÙØ¹ Ø§Ù„Ø­Ø³Ø§Ø¨ Ø¨Ø§Ø³ØªØ®Ø¯Ø§Ù… %@' }],
                  ci: [{ w: 33.95, h: 15, t: 'Ù…ØªØ§Ø¨Ø¹Ø© %@' }],
                  co: [{ w: 51.61, h: 15, t: 'Ù…Ø³Ø§Ù‡Ù…Ø© Ø¨Ù€ %@' }],
                  d: [{ w: 73.14, h: 15, t: 'ØªØ¨Ø±Ø¹ Ø¨Ø§Ø³ØªØ®Ø¯Ø§Ù… %@' }],
                  o: [{ w: 74.09, h: 15, t: 'Ø·Ù„Ø¨ Ø¨Ø§Ø³ØªØ®Ø¯Ø§Ù… %@' }],
                  pa: [{ w: 69.69, h: 15, t: 'Ø¯ÙØ¹ Ø¨Ø§Ø³ØªØ®Ø¯Ø§Ù… %@' }],
                  rl: [{ w: 112.33, h: 15, t: 'Ø¥Ø¹Ø§Ø¯Ø© Ø§Ù„ØªØ¹Ø¨Ø¦Ø© Ø¨Ø§Ø³ØªØ®Ø¯Ø§Ù… %@' }],
                  rn: [{ w: 88.36, h: 15, t: 'Ø§Ø³ØªØ¦Ø¬Ø§Ø± Ø¨Ø§Ø³ØªØ®Ø¯Ø§Ù… %@' }],
                  se: [{ w: 29.02, h: 15, t: 'Ø¥Ø¹Ø¯Ø§Ø¯ %@' }],
                  sb: [{ w: 85.2, h: 15, t: 'Ø§Ø´ØªØ±Ø§Ùƒ Ø¨Ø§Ø³ØªØ®Ø¯Ø§Ù… %@' }],
                  sp: [{ w: 71.73, h: 15.08, t: 'Ø¯Ø¹Ù… Ø¨Ø§Ø³ØªØ®Ø¯Ø§Ù… %@' }],
                  ti: [{ w: 113.48, h: 15, t: 'Ø¯ÙØ¹ Ø§Ù„Ø¥ÙƒØ±Ø§Ù…ÙŠØ© Ø¨Ø§Ø³ØªØ®Ø¯Ø§Ù… %@' }],
                  to: [{ w: 112.78, h: 15, t: 'ØªØ¹Ø¨Ø¦Ø© Ø§Ù„Ø±ØµÙŠØ¯ Ø¨Ø§Ø³ØªØ®Ø¯Ø§Ù… %@' }],
                },
                s: '12px',
                rtl: !0,
                w: 700,
              },
              'da-DK': {
                l: {
                  a: [{ w: 113.38, h: 18, t: 'TilfÃ¸j penge med %@' }],
                  bo: [{ w: 72.86, h: 18, t: 'Bestil med %@' }],
                  bu: [{ w: 62.19, h: 18, t: 'KÃ¸b med %@' }],
                  ch: [{ w: 69.8, h: 18, t: 'Betal med %@' }],
                  ci: [{ w: 88.09, h: 18, t: 'FortsÃ¦t med %@' }],
                  co: [{ w: 79.16, h: 18, t: 'Bidrag med %@' }],
                  d: [{ w: 76.38, h: 18, t: 'Doner med %@' }],
                  o: [{ w: 72.86, h: 18, t: 'Bestil med %@' }],
                  pa: [{ w: 69.8, h: 18, t: 'Betal med %@' }],
                  rl: [{ w: 87.45, h: 18, t: 'Tank op med %@' }],
                  rn: [{ w: 55.41, h: 18, t: 'Lej med %@' }],
                  se: [{ w: 43.45, h: 18, t: 'Indstil %@' }],
                  sb: [{ w: 93.02, h: 18, t: 'Abonner med %@' }],
                  sp: [{ w: 63.41, h: 18, t: 'StÃ¸t med %@' }],
                  ti: [{ w: 143.91, h: 18, t: 'Giv drikkepenge med %@' }],
                  to: [{ w: 84.28, h: 18, t: 'Fyld op med %@' }],
                },
                s: '15px',
                ls: '0.22px',
              },
              'es-MX': {
                l: {
                  a: [{ w: 129.58, h: 18, t: 'Agregar dinero con %@' }],
                  bo: [{ w: 90.03, h: 18, t: 'Reservar con %@' }],
                  bu: [{ w: 89.53, h: 18, t: 'Comprar con %@' }],
                  ch: [{ w: 69.38, h: 18, t: 'Pagar con %@' }],
                  ci: [{ w: 96.92, h: 18, t: 'Continuar con %@' }],
                  co: [{ w: 97.92, h: 18, t: 'Contribuir con %@' }],
                  d: [{ w: 71.52, h: 18, t: 'Donar con %@' }],
                  o: [{ w: 65.34, h: 18, t: 'Pedir con %@' }],
                  pa: [{ w: 69.38, h: 18, t: 'Pagar con %@' }],
                  rl: [{ w: 91.2, h: 18, t: 'Recargar con %@' }],
                  rn: [{ w: 75.05, h: 18, t: 'Rentar con %@' }],
                  se: [{ w: 74.22, h: 18, t: 'Configurar %@' }],
                  sb: [{ w: 105.81, h: 18, t: 'Suscribirse con %@' }],
                  sp: [{ w: 78.77, h: 18, t: 'Apoyar con %@' }],
                  ti: [{ w: 108.42, h: 18, t: 'Dar propina con %@' }],
                  to: [{ w: 124.44, h: 18, t: 'Cubrir el resto con %@' }],
                },
                s: '15px',
                ls: '0.22px',
              },
              'uk-UA': {
                l: {
                  a: [{ w: 121.47, h: 18, t: 'ÐŸÐ¾Ð¿Ð¾Ð²Ð½Ð¸Ñ‚Ð¸ Ñ‡ÐµÑ€ÐµÐ· %@' }],
                  bo: [{ w: 113.38, h: 18, t: 'Ð—Ð°Ð¼Ð¾Ð²Ð¸Ñ‚Ð¸ Ñ‡ÐµÑ€ÐµÐ· %@' }],
                  bu: [{ w: 94.89, h: 18, t: 'ÐšÑƒÐ¿Ð¸Ñ‚Ð¸ Ñ‡ÐµÑ€ÐµÐ· %@' }],
                  ch: [{ w: 119.34, h: 18, t: 'ÐžÑ„Ð¾Ñ€Ð¼Ð¸Ñ‚Ð¸ Ñ‡ÐµÑ€ÐµÐ· %@' }],
                  ci: [{ w: 101, h: 18, t: 'ÐŸÑ€Ð¾Ð´Ð¾Ð²Ð¶Ð¸Ñ‚Ð¸ Ð· %@' }],
                  co: [{ w: 155.2, h: 18, t: 'Ð—Ñ€Ð¾Ð±Ð¸Ñ‚Ð¸ Ð²Ð½ÐµÑÐ¾Ðº Ñ‡ÐµÑ€ÐµÐ· %@' }],
                  d: [{ w: 145.48, h: 18, t: 'ÐŸÐ¾Ð¶ÐµÑ€Ñ‚Ð²ÑƒÐ²Ð°Ñ‚Ð¸ Ñ‡ÐµÑ€ÐµÐ· %@' }],
                  o: [{ w: 113.38, h: 18, t: 'Ð—Ð°Ð¼Ð¾Ð²Ð¸Ñ‚Ð¸ Ñ‡ÐµÑ€ÐµÐ· %@' }],
                  pa: [{ w: 96.17, h: 18, t: 'ÐžÐ¿Ð»Ð°Ñ‚Ð° Ñ‡ÐµÑ€ÐµÐ· %@' }],
                  rl: [{ w: 121.47, h: 18, t: 'ÐŸÐ¾Ð¿Ð¾Ð²Ð½Ð¸Ñ‚Ð¸ Ñ‡ÐµÑ€ÐµÐ· %@' }],
                  rn: [{ w: 129.73, h: 18, t: 'ÐžÑ€ÐµÐ½Ð´ÑƒÐ²Ð°Ñ‚Ð¸ Ñ‡ÐµÑ€ÐµÐ· %@' }],
                  se: [{ w: 95.08, h: 18, t: 'ÐÐ°Ð»Ð°ÑˆÑ‚ÑƒÐ²Ð°Ñ‚Ð¸ %@' }],
                  sb: [{ w: 132.28, h: 18, t: 'ÐŸÑ–Ð´Ð¿Ð¸ÑÐ°Ñ‚Ð¸ÑÑ Ñ‡ÐµÑ€ÐµÐ· %@' }],
                  sp: [{ w: 126.63, h: 18, t: 'ÐŸÑ–Ð´Ñ‚Ñ€Ð¸Ð¼Ð°Ñ‚Ð¸ Ñ‡ÐµÑ€ÐµÐ· %@' }],
                  ti: [{ w: 161.66, h: 18, t: 'Ð—Ð°Ð»Ð¸ÑˆÐ¸Ñ‚Ð¸ Ñ‡Ð°Ð¹Ð¾Ð²Ñ– Ñ‡ÐµÑ€ÐµÐ· %@' }],
                  to: [{ w: 121.47, h: 18, t: 'ÐŸÐ¾Ð¿Ð¾Ð²Ð½Ð¸Ñ‚Ð¸ Ñ‡ÐµÑ€ÐµÐ· %@' }],
                },
                s: '15px',
              },
              'tr-TR': {
                l: {
                  a: [{ w: 82.14, h: 18, t: '%@ ile Para Ekle' }],
                  bo: [{ w: 134.94, h: 18, t: '%@ ile Rezervasyon Yap' }],
                  bu: [{ w: 72.36, h: 18, t: '%@ ile SatÄ±n Al' }],
                  ch: [{ w: 49.59, h: 18, t: '%@ ile Ã–de' }],
                  ci: [{ w: 64.34, h: 18, t: '%@ ile sÃ¼rdÃ¼r' }],
                  co: [{ w: 113.28, h: 18, t: '%@ ile KatkÄ±da Bulun' }],
                  d: [{ w: 86.64, h: 18, t: '%@ ile BaÄŸÄ±ÅŸ Yap' }],
                  o: [{ w: 92.42, h: 18, t: '%@ ile SipariÅŸ Ver' }],
                  pa: [{ w: 49.59, h: 18, t: '%@ ile Ã–de' }],
                  rl: [{ w: 114.63, h: 18, t: '%@ ile Yeniden YÃ¼kle' }],
                  rn: [{ w: 59.02, h: 18, t: '%@ ile Kirala' }],
                  se: [{ w: 48.86, h: 18, t: 'Ayarla: %@' }],
                  sb: [{ w: 83.16, h: 18, t: '%@ ile Abone Ol' }],
                  sp: [{ w: 86.34, h: 18, t: '%@ ile Destek Ol' }],
                  ti: [{ w: 91.27, h: 18, t: '%@ ile BahÅŸiÅŸ Ver' }],
                  to: [{ w: 66.09, h: 18, t: '%@ ile Doldur' }],
                },
                s: '15px',
                ls: '0.22px',
              },
              'th-TH': {
                l: {
                  a: [{ w: 64.11, h: 15, t: 'à¹€à¸•à¸´à¸¡à¹€à¸‡à¸´à¸™à¸”à¹‰à¸§à¸¢ %@' }],
                  bo: [{ w: 45.84, h: 15, t: 'à¸ˆà¸­à¸‡à¸”à¹‰à¸§à¸¢ %@' }],
                  bu: [{ w: 40.47, h: 18.41, t: 'à¸‹à¸·à¹‰à¸­à¸”à¹‰à¸§à¸¢ %@' }],
                  ch: [{ w: 69.86, h: 15, t: 'à¸Šà¸³à¸£à¸°à¹€à¸‡à¸´à¸™à¸”à¹‰à¸§à¸¢ %@' }],
                  ci: [{ w: 96.7, h: 15, t: 'à¸”à¸³à¹€à¸™à¸´à¸™à¸à¸²à¸£à¸•à¹ˆà¸­à¸”à¹‰à¸§à¸¢ %@' }],
                  co: [{ w: 76.97, h: 15, t: 'à¸¡à¸µà¸ªà¹ˆà¸§à¸™à¸£à¹ˆà¸§à¸¡à¸”à¹‰à¸§à¸¢ %@' }],
                  d: [{ w: 61.7, h: 15, t: 'à¸šà¸£à¸´à¸ˆà¸²à¸„à¸”à¹‰à¸§à¸¢ %@' }],
                  o: [{ w: 39.22, h: 17.08, t: 'à¸ªà¸±à¹ˆà¸‡à¸”à¹‰à¸§à¸¢ %@' }],
                  pa: [{ w: 51.52, h: 15, t: 'à¸Šà¸³à¸£à¸°à¸”à¹‰à¸§à¸¢ %@' }],
                  rl: [{ w: 79.27, h: 15.05, t: 'à¹‚à¸«à¸¥à¸”à¹ƒà¸«à¸¡à¹ˆà¸”à¹‰à¸§à¸¢ %@' }],
                  rn: [{ w: 43.58, h: 15, t: 'à¹€à¸Šà¹ˆà¸²à¸”à¹‰à¸§à¸¢ %@' }],
                  se: [{ w: 31.77, h: 17.7, t: 'à¸•à¸±à¹‰à¸‡à¸„à¹ˆà¸² %@' }],
                  sb: [{ w: 70.42, h: 15, t: 'à¸ªà¸¡à¸±à¸„à¸£à¸£à¸±à¸šà¸”à¹‰à¸§à¸¢ %@' }],
                  sp: [{ w: 73.39, h: 15.64, t: 'à¸ªà¸™à¸±à¸šà¸ªà¸™à¸¸à¸™à¸”à¹‰à¸§à¸¢ %@' }],
                  ti: [{ w: 57.23, h: 15, t: 'à¹ƒà¸«à¹‰à¸—à¸´à¸›à¸”à¹‰à¸§à¸¢ %@' }],
                  to: [{ w: 45.75, h: 15, t: 'à¹€à¸•à¸´à¸¡à¸”à¹‰à¸§à¸¢ %@' }],
                },
                s: '13px',
              },
              'ro-RO': {
                l: {
                  a: [{ w: 114.67, h: 18, t: 'AdÄƒugaÈ›i bani cu %@' }],
                  bo: [{ w: 84.72, h: 18, t: 'RezervaÈ›i cu %@' }],
                  bu: [{ w: 92.45, h: 18, t: 'CumpÄƒraÈ›i cu %@' }],
                  ch: [{ w: 151.14, h: 18, t: 'FinalizaÈ›i tranzacÈ›ia cu %@' }],
                  ci: [{ w: 91.88, h: 18, t: 'ContinuaÈ›i cu %@' }],
                  co: [{ w: 92.88, h: 18, t: 'ContribuiÈ›i cu %@' }],
                  d: [{ w: 66.47, h: 18, t: 'DonaÈ›i cu %@' }],
                  o: [{ w: 95.94, h: 18, t: 'ComandaÈ›i cu %@' }],
                  pa: [{ w: 60.25, h: 18, t: 'PlÄƒtiÈ›i cu %@' }],
                  rl: [{ w: 97.3, h: 18, t: 'ReÃ®ncÄƒrcaÈ›i cu %@' }],
                  rn: [{ w: 80.72, h: 18, t: 'ÃŽnchiriaÈ›i cu %@' }],
                  se: [{ w: 77.58, h: 18, t: 'ConfiguraÈ›i %@' }],
                  sb: [{ w: 96.95, h: 18, t: 'AbonaÈ›iâ€‘vÄƒ cu %@' }],
                  sp: [{ w: 92.88, h: 18, t: 'ContribuiÈ›i cu %@' }],
                  ti: [{ w: 110.34, h: 18, t: 'OferiÈ›i bacÈ™iÈ™ cu %@' }],
                  to: [{ w: 97.3, h: 18, t: 'ReÃ®ncÄƒrcaÈ›i cu %@' }],
                },
                s: '15px',
                ls: '0.22px',
              },
              'fi-FI': {
                l: {
                  a: [
                    { w: 78.92, h: 18, t: 'LisÃ¤Ã¤ rahaa ' },
                    { w: 14.75, h: 18, t: 'lla' },
                  ],
                  bo: [
                    { w: 74.11, h: 18, t: 'Tee varaus ' },
                    { w: 14.75, h: 18, t: 'lla' },
                  ],
                  bu: [
                    { w: 34.66, h: 18, t: 'Osta ' },
                    { w: 14.75, h: 18, t: 'lla' },
                  ],
                  ch: [
                    { w: 121.22, h: 18, t: 'Siirry maksamaan ' },
                    { w: 14.75, h: 18, t: 'lla' },
                  ],
                  ci: [
                    { w: 39.81, h: 18, t: 'Jatka ' },
                    { w: 14.75, h: 18, t: 'lla' },
                  ],
                  co: [
                    { w: 56.03, h: 18, t: 'Lahjoita ' },
                    { w: 14.75, h: 18, t: 'lla' },
                  ],
                  d: [
                    { w: 56.03, h: 18, t: 'Lahjoita ' },
                    { w: 14.75, h: 18, t: 'lla' },
                  ],
                  o: [
                    { w: 34.69, h: 18, t: 'Tilaa ' },
                    { w: 14.75, h: 18, t: 'lla' },
                  ],
                  pa: [
                    { w: 46.7, h: 18, t: 'Maksa ' },
                    { w: 14.75, h: 18, t: 'lla' },
                  ],
                  rl: [
                    { w: 40.13, h: 18, t: 'Lataa ' },
                    { w: 14.75, h: 18, t: 'lla' },
                  ],
                  rn: [
                    { w: 57.97, h: 18, t: 'Vuokraa ' },
                    { w: 14.75, h: 18, t: 'lla' },
                  ],
                  se: [
                    { w: 27.25, h: 18, t: 'Ota ' },
                    { w: 61.7, h: 18, t: ' kÃ¤yttÃ¶Ã¶n' },
                  ],
                  sb: [
                    { w: 34.69, h: 18, t: 'Tilaa ' },
                    { w: 14.75, h: 18, t: 'lla' },
                  ],
                  sp: [
                    { w: 27.2, h: 18, t: 'Tue ' },
                    { w: 14.75, h: 18, t: 'lla' },
                  ],
                  ti: [
                    { w: 70.44, h: 18, t: 'Anna tippi ' },
                    { w: 14.75, h: 18, t: 'lla' },
                  ],
                  to: [
                    { w: 68.19, h: 18, t: 'TÃ¤ydennÃ¤ ' },
                    { w: 14.75, h: 18, t: 'lla' },
                  ],
                },
                s: '15px',
                ls: '0.22px',
              },
              'pl-PL': {
                l: {
                  a: [
                    { w: 91.52, h: 18, t: 'Dodaj Å›rodki (' },
                    { w: 5.16, h: 18, t: ')' },
                  ],
                  bo: [{ w: 146.19, h: 18, t: 'Zarezerwuj, uÅ¼ywajÄ…c %@' }],
                  bu: [{ w: 98.39, h: 18, t: 'Kup, uÅ¼ywajÄ…c %@' }],
                  ch: [{ w: 175.7, h: 18, t: 'Sfinalizuj zakup, uÅ¼ywajÄ…c %@' }],
                  ci: [{ w: 80.53, h: 18, t: 'Kontynuuj - %@' }],
                  co: [
                    { w: 92.56, h: 18, t: 'WnieÅ› wkÅ‚ad (' },
                    { w: 5.16, h: 18, t: ')' },
                  ],
                  d: [{ w: 165.52, h: 18, t: 'PrzekaÅ¼ datek, uÅ¼ywajÄ…c %@' }],
                  o: [
                    { w: 58.28, h: 18, t: 'ZamÃ³w (' },
                    { w: 5.16, h: 18, t: ')' },
                  ],
                  pa: [{ w: 117.69, h: 18, t: 'ZapÅ‚aÄ‡, uÅ¼ywajÄ…c %@' }],
                  rl: [
                    { w: 114.61, h: 18, t: 'UzupeÅ‚nij Å›rodki (' },
                    { w: 5.16, h: 18, t: ')' },
                  ],
                  rn: [
                    { w: 77.73, h: 18, t: 'WypoÅ¼ycz (' },
                    { w: 5.16, h: 18, t: ')' },
                  ],
                  se: [{ w: 79.19, h: 18, t: 'Skonfiguruj %@' }],
                  sb: [{ w: 147.33, h: 18, t: 'Subskrybuj, uÅ¼ywajÄ…c %@' }],
                  sp: [
                    { w: 70.06, h: 18, t: 'Wesprzyj (' },
                    { w: 5.16, h: 18, t: ')' },
                  ],
                  ti: [
                    { w: 89.44, h: 18, t: 'Daj napiwek (' },
                    { w: 5.16, h: 18, t: ')' },
                  ],
                  to: [
                    { w: 59.44, h: 18, t: 'DoÅ‚aduj (' },
                    { w: 5.16, h: 18, t: ')' },
                  ],
                },
                s: '15px',
                ls: '0.22px',
              },
              'zh-TW': {
                l: {
                  a: [
                    { w: 17.81, h: 18, t: 'ç”¨ ' },
                    { w: 32.61, h: 18, t: ' å„²å€¼' },
                  ],
                  bo: [
                    { w: 17.81, h: 18, t: 'ç”¨ ' },
                    { w: 32.61, h: 18, t: ' é ç´„' },
                  ],
                  bu: [
                    { w: 17.81, h: 18, t: 'ç”¨ ' },
                    { w: 32.61, h: 18, t: ' è³¼è²·' },
                  ],
                  ch: [
                    { w: 17.81, h: 18, t: 'ç”¨ ' },
                    { w: 32.61, h: 18, t: ' çµå¸³' },
                  ],
                  ci: [
                    { w: 17.81, h: 18, t: 'ç”¨ ' },
                    { w: 32.61, h: 18, t: ' ç¹¼çºŒ' },
                  ],
                  co: [
                    { w: 17.81, h: 18, t: 'ç”¨ ' },
                    { w: 32.61, h: 18, t: ' æåŠ©' },
                  ],
                  d: [
                    { w: 17.81, h: 18, t: 'ç”¨ ' },
                    { w: 32.61, h: 18, t: ' ææ¬¾' },
                  ],
                  o: [
                    { w: 17.81, h: 18, t: 'ç”¨ ' },
                    { w: 32.61, h: 18, t: ' è¨‚è³¼' },
                  ],
                  pa: [
                    { w: 17.81, h: 18, t: 'ç”¨ ' },
                    { w: 32.61, h: 18, t: ' ä»˜æ¬¾' },
                  ],
                  rl: [
                    { w: 17.81, h: 18, t: 'ç”¨ ' },
                    { w: 32.61, h: 18, t: ' å……å€¼' },
                  ],
                  rn: [
                    { w: 17.81, h: 18, t: 'ç”¨ ' },
                    { w: 32.61, h: 18, t: ' ç§Ÿå€Ÿ' },
                  ],
                  se: [{ w: 32.61, h: 18, t: 'è¨­å®š %@' }],
                  sb: [
                    { w: 17.81, h: 18, t: 'ç”¨ ' },
                    { w: 32.61, h: 18, t: ' è¨‚é–±' },
                  ],
                  sp: [
                    { w: 17.81, h: 18, t: 'ç”¨ ' },
                    { w: 32.61, h: 18, t: ' æ”¯æ´' },
                  ],
                  ti: [
                    { w: 17.81, h: 18, t: 'ç”¨ ' },
                    { w: 62.2, h: 18, t: ' æ”¯ä»˜å°è²»' },
                  ],
                  to: [
                    { w: 17.81, h: 18, t: 'ç”¨ ' },
                    { w: 32.61, h: 18, t: ' åŠ å€¼' },
                  ],
                },
                s: '14.8px',
              },
              'fr-CA': {
                l: {
                  a: [{ w: 154.91, h: 18, t: 'Ajouter des fonds avec %@' }],
                  bo: [{ w: 96.92, h: 18, t: 'RÃ©server avec %@' }],
                  bu: [{ w: 90.47, h: 18, t: 'Acheter avec %@' }],
                  ch: [{ w: 75.22, h: 18, t: 'Payer avec %@' }],
                  ci: [{ w: 108.56, h: 18, t: 'Poursuivre avec %@' }],
                  co: [{ w: 109.41, h: 18, t: 'Contribuer avec %@' }],
                  d: [{ w: 118.92, h: 18, t: 'Faire un don avec %@' }],
                  o: [{ w: 120.53, h: 18, t: 'Commander avec %@' }],
                  pa: [{ w: 75.22, h: 18, t: 'Payer avec %@' }],
                  rl: [{ w: 106.7, h: 18, t: 'Recharger avec %@' }],
                  rn: [{ w: 75.95, h: 18, t: 'Louer avec %@' }],
                  se: [{ w: 74.19, h: 18, t: 'Configurer %@' }],
                  sb: [{ w: 105.61, h: 18, t: 'Sâ€™abonner avec %@' }],
                  sp: [{ w: 93.98, h: 18, t: 'Soutenir avec %@' }],
                  ti: [{ w: 174.38, h: 18, t: 'Donner un pourboire avec %@' }],
                  to: [{ w: 106.7, h: 18, t: 'Recharger avec %@' }],
                },
                s: '15px',
                ls: '0.22px',
              },
              'en-GB': {
                l: {
                  a: [{ w: 110.86, h: 18, t: 'Add Money with %@' }],
                  bo: [{ w: 68.8, h: 18, t: 'Book with %@' }],
                  bu: [{ w: 60.39, h: 18, t: 'Buy with %@' }],
                  ch: [{ w: 102.89, h: 18, t: 'Check out with %@' }],
                  ci: [{ w: 95.58, h: 18, t: 'Continue with %@' }],
                  co: [{ w: 105.94, h: 18, t: 'Contribute with %@' }],
                  d: [{ w: 83, h: 18, t: 'Donate with %@' }],
                  o: [{ w: 72.86, h: 18, t: 'Order with %@' }],
                  pa: [{ w: 59, h: 18, t: 'Pay with %@' }],
                  rl: [{ w: 80.89, h: 18, t: 'Reload with %@' }],
                  rn: [{ w: 65.67, h: 18, t: 'Rent with %@' }],
                  se: [{ w: 45.88, h: 18, t: 'Set up %@' }],
                  sb: [{ w: 102.14, h: 18, t: 'Subscribe with %@' }],
                  sp: [{ w: 88.67, h: 18, t: 'Support with %@' }],
                  ti: [{ w: 55.58, h: 18, t: 'Tip with %@' }],
                  to: [{ w: 81.66, h: 18, t: 'Top Up with %@' }],
                },
                s: '15px',
                ls: '0.22px',
              },
              'es-ES': {
                l: {
                  a: [{ w: 120.05, h: 18, t: 'AÃ±adir dinero con %@' }],
                  bo: [{ w: 90.03, h: 18, t: 'Reservar con %@' }],
                  bu: [{ w: 89.53, h: 18, t: 'Comprar con %@' }],
                  ch: [{ w: 69.38, h: 18, t: 'Pagar con %@' }],
                  ci: [{ w: 96.92, h: 18, t: 'Continuar con %@' }],
                  co: [{ w: 97.92, h: 18, t: 'Contribuir con %@' }],
                  d: [{ w: 71.52, h: 18, t: 'Donar con %@' }],
                  o: [{ w: 65.34, h: 18, t: 'Pedir con %@' }],
                  pa: [{ w: 69.38, h: 18, t: 'Pagar con %@' }],
                  rl: [{ w: 91.2, h: 18, t: 'Recargar con %@' }],
                  rn: [{ w: 81.73, h: 18, t: 'Alquilar con %@' }],
                  se: [{ w: 74.22, h: 18, t: 'Configurar %@' }],
                  sb: [{ w: 105.81, h: 18, t: 'Suscribirse con %@' }],
                  sp: [{ w: 97.92, h: 18, t: 'Contribuir con %@' }],
                  ti: [{ w: 108.42, h: 18, t: 'Dar propina con %@' }],
                  to: [{ w: 91.2, h: 18, t: 'Recargar con %@' }],
                },
                s: '15px',
                ls: '0.22px',
              },
              'de-DE': {
                l: {
                  a: [
                    { w: 58.7, h: 18, t: 'Geld mit ' },
                    { w: 77.88, h: 18, t: ' hinzufÃ¼gen' },
                  ],
                  bo: [
                    { w: 24.41, h: 18, t: 'Mit ' },
                    { w: 53.23, h: 18, t: ' buchen' },
                  ],
                  bu: [
                    { w: 24.41, h: 18, t: 'Mit ' },
                    { w: 48.45, h: 18, t: ' kaufen' },
                  ],
                  ch: [
                    { w: 24.41, h: 18, t: 'Mit ' },
                    { w: 63.94, h: 18, t: ' bezahlen' },
                  ],
                  ci: [{ w: 70.61, h: 18, t: 'Weiter mit %@' }],
                  co: [
                    { w: 24.41, h: 18, t: 'Mit ' },
                    { w: 66.64, h: 18, t: ' beitragen' },
                  ],
                  d: [
                    { w: 24.41, h: 18, t: 'Mit ' },
                    { w: 61, h: 18, t: ' spenden' },
                  ],
                  o: [
                    { w: 24.41, h: 18, t: 'Mit ' },
                    { w: 63.91, h: 18, t: ' bestellen' },
                  ],
                  pa: [
                    { w: 24.41, h: 18, t: 'Mit ' },
                    { w: 63.94, h: 18, t: ' bezahlen' },
                  ],
                  rl: [
                    { w: 24.41, h: 18, t: 'Mit ' },
                    { w: 86.28, h: 18, t: ' erneut laden' },
                  ],
                  rn: [
                    { w: 24.41, h: 18, t: 'Mit ' },
                    { w: 43.22, h: 18, t: ' leihen' },
                  ],
                  se: [{ w: 69.55, h: 18, t: '%@ einrichten' }],
                  sb: [
                    { w: 24.41, h: 18, t: 'Mit ' },
                    { w: 77.94, h: 18, t: ' abonnieren' },
                  ],
                  sp: [
                    { w: 24.41, h: 18, t: 'Mit ' },
                    { w: 87.59, h: 18, t: ' unterstÃ¼tzen' },
                  ],
                  ti: [{ w: 64.16, h: 18, t: '%@ Trinkgeld' }],
                  to: [
                    { w: 24.41, h: 18, t: 'Mit ' },
                    { w: 61.42, h: 18, t: ' auffÃ¼llen' },
                  ],
                },
                s: '15px',
                ls: '0.22px',
              },
              'nb-NO': {
                l: {
                  a: [{ w: 135.02, h: 18, t: 'Legg til penger med %@' }],
                  bo: [{ w: 76.34, h: 18, t: 'Bestill med %@' }],
                  bu: [{ w: 66.05, h: 18, t: 'KjÃ¸p med %@' }],
                  ch: [{ w: 69.8, h: 18, t: 'Betal med %@' }],
                  ci: [{ w: 62.28, h: 18, t: 'Fortsett i %@' }],
                  co: [{ w: 70.47, h: 18, t: 'Bidra med %@' }],
                  d: [{ w: 76.38, h: 18, t: 'Doner med %@' }],
                  o: [{ w: 76.34, h: 18, t: 'Bestill med %@' }],
                  pa: [{ w: 69.8, h: 18, t: 'Betal med %@' }],
                  rl: [{ w: 78.59, h: 18, t: 'Fyll pÃ¥ med %@' }],
                  rn: [{ w: 55.41, h: 18, t: 'Lei med %@' }],
                  se: [{ w: 72.77, h: 18, t: 'Konfigurer %@' }],
                  sb: [{ w: 93.02, h: 18, t: 'Abonner med %@' }],
                  sp: [{ w: 68.44, h: 18, t: 'StÃ¸tt med %@' }],
                  ti: [{ w: 85.83, h: 18, t: 'Gi driks med %@' }],
                  to: [{ w: 78.59, h: 18, t: 'Fyll pÃ¥ med %@' }],
                },
                s: '15px',
                ls: '0.22px',
              },
              'ca-ES': {
                l: {
                  a: [{ w: 120.41, h: 18, t: 'Afegir diners amb %@' }],
                  bo: [{ w: 94.61, h: 18, t: 'Reservar amb %@' }],
                  bu: [{ w: 94.11, h: 18, t: 'Comprar amb %@' }],
                  ch: [{ w: 73.97, h: 18, t: 'Pagar amb %@' }],
                  ci: [{ w: 96.38, h: 18, t: 'Continua amb %@' }],
                  co: [{ w: 102.52, h: 18, t: 'Contribuir amb %@' }],
                  d: [{ w: 141.59, h: 18, t: 'Fer una donaciÃ³ amb %@' }],
                  o: [{ w: 96.41, h: 18, t: 'Demanar amb %@' }],
                  pa: [{ w: 73.97, h: 18, t: 'Pagar amb %@' }],
                  rl: [{ w: 109.06, h: 18, t: 'Recarregar amb %@' }],
                  rn: [{ w: 77.56, h: 18, t: 'Llogar amb %@' }],
                  se: [{ w: 74.22, h: 18, t: 'Configurar %@' }],
                  sb: [{ w: 117.7, h: 18, t: 'Subscriureâ€™s amb %@' }],
                  sp: [{ w: 129.63, h: 18, t: 'Compatibilitat amb %@' }],
                  ti: [{ w: 132.08, h: 18, t: 'Deixar propina amb %@' }],
                  to: [{ w: 109.06, h: 18, t: 'Recarregar amb %@' }],
                },
                s: '15px',
                ls: '0.22px',
              },
              'ja-JP': {
                l: {
                  a: [{ w: 75, h: 18, t: '%@ã§ãƒãƒ£ãƒ¼ã‚¸' }],
                  bo: [{ w: 45, h: 18, t: '%@ã§äºˆç´„' }],
                  bu: [{ w: 45, h: 18, t: '%@ã§è³¼å…¥' }],
                  ch: [{ w: 90, h: 18, t: '%@ã§è³¼å…¥ã«é€²ã‚€' }],
                  ci: [{ w: 60, h: 18, t: '%@ã§ç¶šã‘ã‚‹' }],
                  co: [{ w: 45, h: 18, t: '%@ã§çŒ®é‡‘' }],
                  d: [{ w: 45, h: 18, t: '%@ã§å¯„ä»˜' }],
                  o: [{ w: 45, h: 18, t: '%@ã§æ³¨æ–‡' }],
                  pa: [{ w: 60, h: 18, t: '%@ã§æ”¯æ‰•ã†' }],
                  rl: [{ w: 75, h: 18, t: '%@ã§ãƒãƒ£ãƒ¼ã‚¸' }],
                  rn: [{ w: 75, h: 18, t: '%@ã§ãƒ¬ãƒ³ã‚¿ãƒ«' }],
                  se: [{ w: 45, h: 18, t: '%@ã‚’è¨­å®š' }],
                  sb: [{ w: 150, h: 18, t: '%@ã§ã‚µãƒ–ã‚¹ã‚¯ãƒªãƒ—ã‚·ãƒ§ãƒ³' }],
                  sp: [{ w: 45, h: 18, t: '%@ã§æ”¯æ´' }],
                  ti: [{ w: 60, h: 18, t: '%@ã§ãƒãƒƒãƒ—' }],
                  to: [{ w: 75, h: 18, t: '%@ã§ãƒãƒ£ãƒ¼ã‚¸' }],
                },
                s: '15px',
                w: 600,
              },
              'vi-VN': {
                l: {
                  a: [{ w: 95.7, h: 18, t: 'Náº¡p tiá»n báº±ng %@' }],
                  bo: [{ w: 91.86, h: 18, t: 'Äáº·t chá»— báº±ng %@' }],
                  bu: [{ w: 69.39, h: 18, t: 'Mua báº±ng %@' }],
                  ch: [{ w: 115.56, h: 18, t: 'Thanh toÃ¡n báº±ng %@' }],
                  ci: [{ w: 93.8, h: 18, t: 'Tiáº¿p tá»¥c báº±ng %@' }],
                  co: [{ w: 105.2, h: 18, t: 'ÄÃ³ng gÃ³p báº±ng %@' }],
                  d: [{ w: 113.02, h: 18, t: 'QuyÃªn gÃ³p báº±ng %@' }],
                  o: [{ w: 100.55, h: 18, t: 'Äáº·t hÃ ng báº±ng %@' }],
                  pa: [{ w: 115.56, h: 18, t: 'Thanh toÃ¡n báº±ng %@' }],
                  rl: [{ w: 85.63, h: 18, t: 'Náº¡p láº¡i báº±ng %@' }],
                  rn: [{ w: 74.27, h: 18, t: 'ThuÃª báº±ng %@' }],
                  se: [{ w: 60.72, h: 18, t: 'Thiáº¿t láº­p %@' }],
                  sb: [{ w: 94.59, h: 18, t: 'ÄÄƒng kÃ½ báº±ng %@' }],
                  sp: [{ w: 81.38, h: 18, t: 'Há»— trá»£ báº±ng %@' }],
                  ti: [{ w: 61, h: 18, t: 'Tip báº±ng %@' }],
                  to: [{ w: 95.7, h: 18, t: 'Náº¡p tiá»n báº±ng %@' }],
                },
                s: '15px',
                ls: '0.22px',
              },
              'nl-NL': {
                l: {
                  a: [{ w: 123.2, h: 18, t: 'Voeg geld toe met %@' }],
                  bo: [{ w: 99.25, h: 18, t: 'Reserveer met %@' }],
                  bu: [{ w: 66.8, h: 18, t: 'Koop met %@' }],
                  ch: [{ w: 74.06, h: 18, t: 'Betaal met %@' }],
                  ci: [{ w: 96.69, h: 18, t: 'Ga verder met %@' }],
                  co: [{ w: 144.58, h: 18, t: 'Doe een bijdrage met %@' }],
                  d: [{ w: 80.8, h: 18, t: 'Doneer met %@' }],
                  o: [{ w: 73.63, h: 18, t: 'Bestel met %@' }],
                  pa: [{ w: 74.06, h: 18, t: 'Betaal met %@' }],
                  rl: [{ w: 125.09, h: 18, t: 'Laad opnieuw met %@' }],
                  rn: [{ w: 64.84, h: 18, t: 'Huur met %@' }],
                  se: [{ w: 82.33, h: 18, t: 'Configureer %@' }],
                  sb: [{ w: 112.31, h: 18, t: 'Abonneer je met %@' }],
                  sp: [{ w: 71.16, h: 18, t: 'Steun met %@' }],
                  ti: [{ w: 92.61, h: 18, t: 'Geef fooi met %@' }],
                  to: [{ w: 88.31, h: 18, t: 'Verhoog met %@' }],
                },
                s: '15px',
                ls: '0.22px',
              },
              'cs-CZ': {
                l: {
                  a: [{ w: 114.92, h: 18, t: 'PÅ™idat hotovost s %@' }],
                  bo: [{ w: 100.98, h: 18, t: 'Zarezervovat s %@' }],
                  bu: [{ w: 56.98, h: 18, t: 'Koupit s %@' }],
                  ch: [{ w: 65.02, h: 18, t: 'Zaplatit s %@' }],
                  ci: [{ w: 88.44, h: 18, t: 'PokraÄovat s %@' }],
                  co: [{ w: 60.81, h: 18, t: 'PÅ™ispÄ›t s %@' }],
                  d: [{ w: 65.84, h: 18, t: 'Darovat s %@' }],
                  o: [{ w: 75.61, h: 18, t: 'Objednat s %@' }],
                  pa: [{ w: 65.02, h: 18, t: 'Zaplatit s %@' }],
                  rl: [{ w: 49.97, h: 18, t: 'DobÃ­t s %@' }],
                  rn: [{ w: 68.38, h: 18, t: 'VypÅ¯jÄit s %@' }],
                  se: [{ w: 58.19, h: 18, t: 'Nastavit %@' }],
                  sb: [{ w: 78.28, h: 18, t: 'PÅ™edplatit s %@' }],
                  sp: [{ w: 70.45, h: 18, t: 'PodpoÅ™it s %@' }],
                  ti: [{ w: 103.66, h: 18, t: 'DÃ¡t spropitnÃ© s %@' }],
                  to: [{ w: 61.77, h: 18, t: 'Doplnit s %@' }],
                },
                s: '15px',
                ls: '0.22px',
              },
              'sv-SE': {
                l: {
                  a: [{ w: 138.39, h: 18, t: 'LÃ¤gg till pengar med %@' }],
                  bo: [{ w: 69.44, h: 18, t: 'Boka med %@' }],
                  bu: [{ w: 62.11, h: 18, t: 'KÃ¶p med %@' }],
                  ch: [{ w: 77.78, h: 18, t: 'Betala med %@' }],
                  ci: [{ w: 88.16, h: 18, t: 'FortsÃ¤tt med %@' }],
                  co: [{ w: 70.47, h: 18, t: 'Bidra med %@' }],
                  d: [{ w: 84.2, h: 18, t: 'Donera med %@' }],
                  o: [{ w: 80.8, h: 18, t: 'BestÃ¤ll med %@' }],
                  pa: [{ w: 77.78, h: 18, t: 'Betala med %@' }],
                  rl: [{ w: 78.59, h: 18, t: 'Fyll pÃ¥ med %@' }],
                  rn: [{ w: 59.63, h: 18, t: 'Hyr med %@' }],
                  se: [{ w: 47.42, h: 18, t: 'StÃ¤ll in %@' }],
                  sb: [{ w: 121.25, h: 18, t: 'Prenumerera med %@' }],
                  sp: [{ w: 67.13, h: 18, t: 'StÃ¶d med %@' }],
                  ti: [{ w: 98.45, h: 18, t: 'Ge dricks med %@' }],
                  to: [{ w: 78.59, h: 18, t: 'Fyll pÃ¥ med %@' }],
                },
                s: '15px',
                ls: '0.22px',
              },
              'it-IT': {
                l: {
                  a: [{ w: 118.47, h: 18, t: 'Versa denaro con %@' }],
                  bo: [{ w: 82.81, h: 18, t: 'Prenota con %@' }],
                  bu: [{ w: 89.77, h: 18, t: 'Acquista con %@' }],
                  ch: [{ w: 64.23, h: 18, t: 'Paga con %@' }],
                  ci: [{ w: 91.78, h: 18, t: 'Continua con %@' }],
                  co: [{ w: 111.69, h: 18, t: 'Contribuisci con %@' }],
                  d: [{ w: 150.94, h: 18, t: 'Fai una donazione con %@' }],
                  o: [{ w: 75.78, h: 18, t: 'Ordina con %@' }],
                  pa: [{ w: 64.23, h: 18, t: 'Paga con %@' }],
                  rl: [{ w: 84.5, h: 18, t: 'Ricarica con %@' }],
                  rn: [{ w: 90.75, h: 18, t: 'Noleggia con %@' }],
                  se: [{ w: 69.08, h: 18, t: 'Configura %@' }],
                  sb: [{ w: 91.91, h: 18, t: 'Abbonati con %@' }],
                  sp: [{ w: 84.77, h: 18, t: 'Sostieni con %@' }],
                  ti: [{ w: 153.83, h: 18, t: 'Lascia una mancia con %@' }],
                  to: [{ w: 84.5, h: 18, t: 'Ricarica con %@' }],
                },
                s: '15px',
                ls: '0.22px',
              },
              'hr-HR': {
                l: {
                  a: [{ w: 145.14, h: 18, t: 'Dodaj novac koristeÄ‡i %@' }],
                  bo: [{ w: 128.28, h: 18, t: 'Rezerviraj koristeÄ‡i %@' }],
                  bu: [{ w: 92.84, h: 18, t: 'Kupi koristeÄ‡i %@' }],
                  ch: [{ w: 114.06, h: 18, t: 'Naplati koristeÄ‡i: %@' }],
                  ci: [{ w: 63.89, h: 18, t: 'Nastavi s %@' }],
                  co: [{ w: 126.33, h: 18, t: 'Doprinesi koristeÄ‡i %@' }],
                  d: [{ w: 109.88, h: 18, t: 'Doniraj koristeÄ‡i %@' }],
                  o: [{ w: 106.19, h: 18, t: 'NaruÄi koristeÄ‡i %@' }],
                  pa: [{ w: 91.72, h: 18, t: 'Plati koristeÄ‡i %@' }],
                  rl: [{ w: 110.16, h: 18, t: 'Napuni koristeÄ‡i %@' }],
                  rn: [{ w: 109.28, h: 18, t: 'Unajmi koristeÄ‡i %@' }],
                  se: [{ w: 48.05, h: 18, t: 'Podesi %@' }],
                  sb: [{ w: 137.25, h: 18, t: 'Pretplati se koristeÄ‡i %@' }],
                  sp: [{ w: 104.63, h: 18, t: 'PodrÅ¾i koristeÄ‡i %@' }],
                  ti: [{ w: 173.84, h: 18, t: 'Ostavi napojnicu koristeÄ‡i %@' }],
                  to: [{ w: 127.06, h: 18, t: 'Nadoplati koristeÄ‡i %@' }],
                },
                s: '15px',
                ls: '0.22px',
              },
              'id-ID': {
                l: {
                  a: [{ w: 146.39, h: 18, t: 'Tambah uang dengan %@' }],
                  bo: [{ w: 97.41, h: 18, t: 'Pesan dengan %@' }],
                  bu: [{ w: 81.23, h: 18, t: 'Beli dengan %@' }],
                  ch: [{ w: 138.91, h: 18, t: 'Lanjut bayar dengan %@' }],
                  ci: [{ w: 122.27, h: 18, t: 'Lanjutkan dengan %@' }],
                  co: [{ w: 145.36, h: 18, t: 'Berkontribusi dengan %@' }],
                  d: [{ w: 102.89, h: 18, t: 'Donasi dengan %@' }],
                  o: [{ w: 94.8, h: 18, t: 'Order dengan %@' }],
                  pa: [{ w: 94.91, h: 18, t: 'Bayar dengan %@' }],
                  rl: [{ w: 113.94, h: 18, t: 'Isi Ulang dengan %@' }],
                  rn: [{ w: 93.31, h: 18, t: 'Sewa dengan %@' }],
                  se: [{ w: 31.2, h: 18, t: 'Atur %@' }],
                  sb: [{ w: 149.42, h: 18, t: 'Berlangganan dengan %@' }],
                  sp: [{ w: 108.81, h: 18, t: 'Dukung dengan %@' }],
                  ti: [{ w: 103.34, h: 18, t: 'Beri tip dengan %@' }],
                  to: [{ w: 147.81, h: 18, t: 'Tambah Dana dengan %@' }],
                },
                s: '15px',
                ls: '0.22px',
              },
              'hu-HU': {
                l: {
                  a: [{ w: 160.58, h: 18, t: 'PÃ©nz hozzÃ¡adÃ¡sa ezzel: %@' }],
                  bo: [{ w: 113.28, h: 18, t: 'LefoglalÃ¡s ezzel: %@' }],
                  bu: [{ w: 129.64, h: 18, t: 'MegvÃ¡sÃ¡rlÃ¡s ezzel: %@' }],
                  ch: [{ w: 116.84, h: 18, t: 'KasszÃ¡hoz ezzel: %@' }],
                  ci: [{ w: 105.84, h: 18, t: 'FolytatÃ¡s ezzel: %@' }],
                  co: [{ w: 130.72, h: 18, t: 'HozzÃ¡jÃ¡rulÃ¡s ezzel: %@' }],
                  d: [{ w: 139.45, h: 18, t: 'AdomÃ¡nyozÃ¡s ezzel: %@' }],
                  o: [{ w: 131.88, h: 18, t: 'MegrendelÃ©s ezzel: %@' }],
                  pa: [{ w: 92.38, h: 18, t: 'FizetÃ©s ezzel: %@' }],
                  rl: [{ w: 109.23, h: 18, t: 'ÃšjratÃ¶ltÃ©s ezzel: %@' }],
                  rn: [{ w: 120.95, h: 18, t: 'KÃ¶lcsÃ¶nzÃ©s ezzel: %@' }],
                  se: [{ w: 66.75, h: 18, t: '%@ beÃ¡llÃ­tÃ¡sa' }],
                  sb: [{ w: 109.69, h: 18, t: 'ElÅ‘fizetÃ©s ezzel: %@' }],
                  sp: [{ w: 118.05, h: 18, t: 'TÃ¡mogatÃ¡s ezzel: %@' }],
                  ti: [{ w: 108.28, h: 18, t: 'BorravalÃ³ ezzel: %@' }],
                  to: [{ w: 101.67, h: 18, t: 'FeltÃ¶ltÃ©s ezzel: %@' }],
                },
                s: '15px',
                ls: '0.22px',
              },
              'ru-RU': {
                l: {
                  a: [{ w: 134.39, h: 18, t: 'Ð”Ð¾Ð±Ð°Ð²Ð¸Ñ‚ÑŒ Ð´ÐµÐ½ÑŒÐ³Ð¸ Ñ %@' }],
                  bo: [{ w: 77.81, h: 18, t: 'Ð—Ð°ÐºÐ°Ð·Ð°Ñ‚ÑŒ Ñ %@' }],
                  bu: [{ w: 63.44, h: 18, t: 'ÐšÑƒÐ¿Ð¸Ñ‚ÑŒ Ñ %@' }],
                  ch: [{ w: 81.38, h: 18, t: 'ÐžÐ¿Ð»Ð°Ñ‚Ð¸Ñ‚ÑŒ Ñ %@' }],
                  ci: [{ w: 103.5, h: 18, t: 'ÐŸÑ€Ð¾Ð´Ð¾Ð»Ð¶Ð¸Ñ‚ÑŒ Ñ %@' }],
                  co: [{ w: 89.8, h: 18, t: 'ÐžÑ‚Ð¿Ñ€Ð°Ð²Ð¸Ñ‚ÑŒ Ñ %@' }],
                  d: [{ w: 116.05, h: 18, t: 'ÐŸÐ¾Ð¶ÐµÑ€Ñ‚Ð²Ð¾Ð²Ð°Ñ‚ÑŒ Ñ %@' }],
                  o: [{ w: 77.81, h: 18, t: 'Ð—Ð°ÐºÐ°Ð·Ð°Ñ‚ÑŒ Ñ %@' }],
                  pa: [{ w: 81.38, h: 18, t: 'ÐžÐ¿Ð»Ð°Ñ‚Ð¸Ñ‚ÑŒ Ñ %@' }],
                  rl: [{ w: 90.94, h: 18, t: 'ÐŸÐ¾Ð¿Ð¾Ð»Ð½Ð¸Ñ‚ÑŒ Ñ %@' }],
                  rn: [{ w: 98.55, h: 18, t: 'ÐÑ€ÐµÐ½Ð´Ð¾Ð²Ð°Ñ‚ÑŒ Ñ %@' }],
                  se: [{ w: 78.13, h: 18, t: 'ÐÐ°ÑÑ‚Ñ€Ð¾Ð¸Ñ‚ÑŒ %@' }],
                  sb: [{ w: 106.73, h: 18, t: 'ÐŸÐ¾Ð´Ð¿Ð¸ÑÐ°Ñ‚ÑŒÑÑ Ñ %@' }],
                  sp: [{ w: 103.39, h: 18, t: 'ÐŸÐ¾Ð´Ð´ÐµÑ€Ð¶Ð°Ñ‚ÑŒ Ñ %@' }],
                  ti: [{ w: 144.09, h: 18, t: 'ÐžÑ‚Ð¿Ñ€Ð°Ð²Ð¸Ñ‚ÑŒ Ñ‡Ð°ÐµÐ²Ñ‹Ðµ Ñ %@' }],
                  to: [{ w: 90.94, h: 18, t: 'ÐŸÐ¾Ð¿Ð¾Ð»Ð½Ð¸Ñ‚ÑŒ Ñ %@' }],
                },
                s: '15px',
                ls: '0.22px',
              },
              'ko-KR': {
                l: {
                  a: [{ w: 92.2, h: 17, t: '%@(ìœ¼)ë¡œ ê¸ˆì•¡ ì¶©ì „' }],
                  bo: [{ w: 63.84, h: 17, t: '%@(ìœ¼)ë¡œ ì˜ˆì•½' }],
                  bu: [{ w: 63.77, h: 17, t: '%@(ìœ¼)ë¡œ êµ¬ìž…' }],
                  ch: [{ w: 88.33, h: 17, t: '%@(ìœ¼)ë¡œ ì²´í¬ì•„ì›ƒ' }],
                  ci: [{ w: 92.2, h: 17, t: '%@(ìœ¼)ë¡œ ê³„ì† ì§„í–‰' }],
                  co: [{ w: 63.77, h: 17, t: '%@(ìœ¼)ë¡œ ê¸°ë¶€' }],
                  d: [{ w: 63.77, h: 17, t: '%@(ìœ¼)ë¡œ ê¸°ë¶€' }],
                  o: [{ w: 63.77, h: 17, t: '%@(ìœ¼)ë¡œ ì£¼ë¬¸' }],
                  pa: [{ w: 63.77, h: 17, t: '%@(ìœ¼)ë¡œ ì§€ë¶ˆ' }],
                  rl: [{ w: 104.48, h: 17, t: '%@(ìœ¼)ë¡œ ë‹¤ì‹œ ì±„ìš°ê¸°' }],
                  rn: [{ w: 63.77, h: 17, t: '%@(ìœ¼)ë¡œ ëŒ€ì—¬' }],
                  se: [{ w: 27.45, h: 17, t: '%@ ì„¤ì •' }],
                  sb: [{ w: 63.77, h: 17, t: '%@(ìœ¼)ë¡œ êµ¬ë…' }],
                  sp: [{ w: 63.77, h: 17, t: '%@(ìœ¼)ë¡œ ì§€ì›' }],
                  ti: [{ w: 79.94, h: 17, t: '%@(ìœ¼)ë¡œ íŒ ì£¼ê¸°' }],
                  to: [{ w: 152.05, h: 17, t: '%@(ìœ¼)ë¡œ ìš”ê¸ˆ ì¶©ì „(top-up)' }],
                },
                s: '14.2px',
                w: 600,
                ls: '1px',
              },
              'pt-PT': {
                l: {
                  a: [{ w: 155.92, h: 18, t: 'Adicionar dinheiro com %@' }],
                  bo: [{ w: 94.23, h: 18, t: 'Reservar com %@' }],
                  bu: [{ w: 93.73, h: 18, t: 'Comprar com %@' }],
                  ch: [{ w: 73.58, h: 18, t: 'Pagar com %@' }],
                  ci: [{ w: 101.13, h: 18, t: 'Continuar com %@' }],
                  co: [{ w: 102.14, h: 18, t: 'Contribuir com %@' }],
                  d: [{ w: 156.5, h: 18, t: 'Fazer uma doaÃ§Ã£o com %@' }],
                  o: [{ w: 119.66, h: 18, t: 'Encomendar com %@' }],
                  pa: [{ w: 73.58, h: 18, t: 'Pagar com %@' }],
                  rl: [{ w: 108.69, h: 18, t: 'Recarregar com %@' }],
                  rn: [{ w: 78.98, h: 18, t: 'Alugar com %@' }],
                  se: [{ w: 74.22, h: 18, t: 'Configurar %@' }],
                  sb: [{ w: 85.17, h: 18, t: 'Assinar com %@' }],
                  sp: [{ w: 78.98, h: 18, t: 'Apoiar com %@' }],
                  ti: [{ w: 108.94, h: 18, t: 'Dar gorjeta com %@' }],
                  to: [{ w: 93.81, h: 18, t: 'Carregar com %@' }],
                },
                s: '15px',
                ls: '0.22px',
              },
              'hi-IN': {
                l: {
                  a: [{ w: 49.42, h: 14.28, t: '%@ à¤¸à¥‡ à¤§à¤¨ à¤œà¥‹à¤¡à¤¼à¥‡à¤‚' }],
                  bo: [{ w: 47.23, h: 14.89, t: '%@ à¤¸à¥‡ à¤¬à¥à¤• à¤•à¤°à¥‡à¤‚' }],
                  bu: [{ w: 38.5, h: 14.42, t: '%@ à¤¸à¥‡ à¤–à¤¼à¤°à¥€à¤¦à¥‡à¤‚' }],
                  ch: [{ w: 96.38, h: 14.28, t: '%@ à¤•à¥‡ à¤¸à¤¾à¤¥ à¤šà¥‡à¤•à¤†à¤‰à¤Ÿ à¤•à¤°à¥‡à¤‚' }],
                  ci: [{ w: 75.66, h: 14.42, t: '%@ à¤•à¥‡ à¤¸à¤¾à¤¥ à¤œà¤¾à¤°à¥€ à¤°à¤–à¥‡à¤‚' }],
                  co: [{ w: 65.02, h: 14.28, t: '%@ à¤¸à¥‡ à¤¯à¥‹à¤—à¤¦à¤¾à¤¨ à¤•à¤°à¥‡à¤‚' }],
                  d: [{ w: 38.94, h: 14.28, t: '%@ à¤¸à¥‡ à¤¦à¤¾à¤¨ à¤¦à¥‡à¤‚' }],
                  o: [{ w: 55.03, h: 14.34, t: '%@ à¤¸à¥‡ à¤‘à¤°à¥à¤¡à¤° à¤•à¤°à¥‡à¤‚' }],
                  pa: [{ w: 61.91, h: 14.89, t: '%@ à¤¸à¥‡ à¤­à¥à¤—à¤¤à¤¾à¤¨ à¤•à¤°à¥‡à¤‚' }],
                  rl: [{ w: 58.19, h: 14.42, t: '%@ à¤¸à¥‡ à¤°à¥€à¤²à¥‹à¤¡ à¤•à¤°à¥‡à¤‚' }],
                  rn: [{ w: 67.59, h: 14.42, t: '%@ à¤¸à¥‡ à¤•à¤¿à¤°à¤¾à¤ à¤ªà¤° à¤²à¥‡à¤‚' }],
                  se: [{ w: 50.67, h: 14.28, t: '%@ à¤¸à¥‡à¤Ÿà¤…à¤ª à¤•à¤°à¥‡à¤‚' }],
                  sb: [{ w: 102.09, h: 14.28, t: '%@ à¤•à¥‡ à¤¸à¤¾à¤¥ à¤¸à¤¬à¥à¤¸à¤•à¥à¤°à¤¾à¤‡à¤¬ à¤•à¤°à¥‡à¤‚' }],
                  sp: [{ w: 61.06, h: 14.34, t: '%@ à¤¸à¥‡ à¤¸à¤®à¤°à¥à¤¥à¤¨ à¤•à¤°à¥‡à¤‚' }],
                  ti: [{ w: 39.22, h: 14.42, t: '%@ à¤¸à¥‡ à¤Ÿà¤¿à¤ª à¤¦à¥‡à¤‚' }],
                  to: [{ w: 65.84, h: 14.28, t: '%@ à¤¸à¥‡ à¤Ÿà¥‰à¤ª à¤…à¤ª à¤•à¤°à¥‡à¤‚' }],
                },
                s: '12px',
                w: 600,
              },
              'sk-SK': {
                l: {
                  a: [{ w: 124.89, h: 18, t: 'PridaÅ¥ peniaze cez %@' }],
                  bo: [{ w: 104.45, h: 18, t: 'RezervovaÅ¥ cez %@' }],
                  bu: [{ w: 65.42, h: 18, t: 'KÃºpiÅ¥ cez %@' }],
                  ch: [{ w: 81.42, h: 18, t: 'ZaplatiÅ¥ cez %@' }],
                  ci: [{ w: 100.61, h: 18, t: 'PokraÄujte cez %@' }],
                  co: [{ w: 80.69, h: 18, t: 'PrispieÅ¥ cez %@' }],
                  d: [{ w: 80.69, h: 18, t: 'PrispieÅ¥ cez %@' }],
                  o: [{ w: 92.02, h: 18, t: 'ObjednaÅ¥ cez %@' }],
                  pa: [{ w: 81.42, h: 18, t: 'ZaplatiÅ¥ cez %@' }],
                  rl: [{ w: 66.38, h: 18, t: 'DobiÅ¥ cez %@' }],
                  rn: [{ w: 79.02, h: 18, t: 'PoÅ¾iÄaÅ¥ cez %@' }],
                  se: [{ w: 58.52, h: 18, t: 'NastaviÅ¥ %@' }],
                  sb: [{ w: 93.55, h: 18, t: 'OdoberaÅ¥ cez %@' }],
                  sp: [{ w: 86.86, h: 18, t: 'PodporiÅ¥ cez %@' }],
                  ti: [{ w: 119.8, h: 18, t: 'DaÅ¥ sprepitnÃ© cez %@' }],
                  to: [{ w: 66.38, h: 18, t: 'DobiÅ¥ cez %@' }],
                },
                s: '15px',
                ls: '0.22px',
              },
              'ms-MY': {
                l: {
                  a: [{ w: 151.3, h: 18, t: 'Tambah Wang dengan %@' }],
                  bo: [{ w: 109.78, h: 18, t: 'Tempah dengan %@' }],
                  bu: [{ w: 81.23, h: 18, t: 'Beli dengan %@' }],
                  ch: [{ w: 94.91, h: 18, t: 'Bayar dengan %@' }],
                  ci: [{ w: 117.09, h: 18, t: 'Teruskan dengan %@' }],
                  co: [{ w: 144.94, h: 18, t: 'Sumbangkan dengan %@' }],
                  d: [{ w: 101.03, h: 18, t: 'Derma dengan %@' }],
                  o: [{ w: 97.41, h: 18, t: 'Pesan dengan %@' }],
                  pa: [{ w: 94.91, h: 18, t: 'Bayar dengan %@' }],
                  rl: [{ w: 122.72, h: 18, t: 'Isi semula dengan %@' }],
                  rn: [{ w: 93.31, h: 18, t: 'Sewa dengan %@' }],
                  se: [{ w: 64.88, h: 18, t: 'Sediakan %@' }],
                  sb: [{ w: 114.98, h: 18, t: 'Langgan dengan %@' }],
                  sp: [{ w: 107.3, h: 18, t: 'Sokong dengan %@' }],
                  ti: [{ w: 127.48, h: 18, t: 'Berikan tip dengan %@' }],
                  to: [{ w: 142.14, h: 18, t: 'Tambah Nilai dengan %@' }],
                },
                s: '15px',
                ls: '0.22px',
              },
            },
            L = (function () {
              if ('undefined' != typeof Map) return Map;
              function t(t, e) {
                var n = -1;
                return (
                  t.some(function (t, r) {
                    return t[0] === e && ((n = r), !0);
                  }),
                  n
                );
              }
              return (function () {
                function e() {
                  this.__entries__ = [];
                }
                return (
                  Object.defineProperty(e.prototype, 'size', {
                    get: function () {
                      return this.__entries__.length;
                    },
                    enumerable: !0,
                    configurable: !0,
                  }),
                  (e.prototype.get = function (e) {
                    var n = t(this.__entries__, e),
                      r = this.__entries__[n];
                    return r && r[1];
                  }),
                  (e.prototype.set = function (e, n) {
                    var r = t(this.__entries__, e);
                    ~r ? (this.__entries__[r][1] = n) : this.__entries__.push([e, n]);
                  }),
                  (e.prototype.delete = function (e) {
                    var n = this.__entries__,
                      r = t(n, e);
                    ~r && n.splice(r, 1);
                  }),
                  (e.prototype.has = function (e) {
                    return !!~t(this.__entries__, e);
                  }),
                  (e.prototype.clear = function () {
                    this.__entries__.splice(0);
                  }),
                  (e.prototype.forEach = function (t, e) {
                    void 0 === e && (e = null);
                    for (var n = 0, r = this.__entries__; n < r.length; n++) {
                      var a = r[n];
                      t.call(e, a[1], a[0]);
                    }
                  }),
                  e
                );
              })();
            })(),
            _ = 'undefined' != typeof window && 'undefined' != typeof document && window.document === document,
            R =
              void 0 !== t && t.Math === Math
                ? t
                : 'undefined' != typeof self && self.Math === Math
                ? self
                : 'undefined' != typeof window && window.Math === Math
                ? window
                : Function('return this')(),
            N =
              'function' == typeof requestAnimationFrame
                ? requestAnimationFrame.bind(R)
                : function (t) {
                    return setTimeout(function () {
                      return t(Date.now());
                    }, 1e3 / 60);
                  };
          var T = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'],
            z = 'undefined' != typeof MutationObserver,
            O = (function () {
              function t() {
                (this.connected_ = !1),
                  (this.mutationEventsAdded_ = !1),
                  (this.mutationsObserver_ = null),
                  (this.observers_ = []),
                  (this.onTransitionEnd_ = this.onTransitionEnd_.bind(this)),
                  (this.refresh = (function (t, e) {
                    var n = !1,
                      r = !1,
                      a = 0;
                    function o() {
                      n && ((n = !1), t()), r && s();
                    }
                    function i() {
                      N(o);
                    }
                    function s() {
                      var t = Date.now();
                      if (n) {
                        if (t - a < 2) return;
                        r = !0;
                      } else (n = !0), (r = !1), setTimeout(i, e);
                      a = t;
                    }
                    return s;
                  })(this.refresh.bind(this), 20));
              }
              return (
                (t.prototype.addObserver = function (t) {
                  ~this.observers_.indexOf(t) || this.observers_.push(t), this.connected_ || this.connect_();
                }),
                (t.prototype.removeObserver = function (t) {
                  var e = this.observers_,
                    n = e.indexOf(t);
                  ~n && e.splice(n, 1), !e.length && this.connected_ && this.disconnect_();
                }),
                (t.prototype.refresh = function () {
                  this.updateObservers_() && this.refresh();
                }),
                (t.prototype.updateObservers_ = function () {
                  var t = this.observers_.filter(function (t) {
                    return t.gatherActive(), t.hasActive();
                  });
                  return (
                    t.forEach(function (t) {
                      return t.broadcastActive();
                    }),
                    t.length > 0
                  );
                }),
                (t.prototype.connect_ = function () {
                  _ &&
                    !this.connected_ &&
                    (document.addEventListener('transitionend', this.onTransitionEnd_),
                    window.addEventListener('resize', this.refresh),
                    z
                      ? ((this.mutationsObserver_ = new MutationObserver(this.refresh)),
                        this.mutationsObserver_.observe(document, { attributes: !0, childList: !0, characterData: !0, subtree: !0 }))
                      : (document.addEventListener('DOMSubtreeModified', this.refresh), (this.mutationEventsAdded_ = !0)),
                    (this.connected_ = !0));
                }),
                (t.prototype.disconnect_ = function () {
                  _ &&
                    this.connected_ &&
                    (document.removeEventListener('transitionend', this.onTransitionEnd_),
                    window.removeEventListener('resize', this.refresh),
                    this.mutationsObserver_ && this.mutationsObserver_.disconnect(),
                    this.mutationEventsAdded_ && document.removeEventListener('DOMSubtreeModified', this.refresh),
                    (this.mutationsObserver_ = null),
                    (this.mutationEventsAdded_ = !1),
                    (this.connected_ = !1));
                }),
                (t.prototype.onTransitionEnd_ = function (t) {
                  var e = t.propertyName,
                    n = void 0 === e ? '' : e;
                  T.some(function (t) {
                    return !!~n.indexOf(t);
                  }) && this.refresh();
                }),
                (t.getInstance = function () {
                  return this.instance_ || (this.instance_ = new t()), this.instance_;
                }),
                (t.instance_ = null),
                t
              );
            })(),
            A = function (t, e) {
              for (var n = 0, r = Object.keys(e); n < r.length; n++) {
                var a = r[n];
                Object.defineProperty(t, a, { value: e[a], enumerable: !1, writable: !1, configurable: !0 });
              }
              return t;
            },
            j = function (t) {
              return (t && t.ownerDocument && t.ownerDocument.defaultView) || R;
            },
            E = I(0, 0, 0, 0);
          function M(t) {
            return parseFloat(t) || 0;
          }
          function P(t) {
            for (var e = [], n = 1; n < arguments.length; n++) e[n - 1] = arguments[n];
            return e.reduce(function (e, n) {
              return e + M(t['border-' + n + '-width']);
            }, 0);
          }
          function B(t) {
            var e = t.clientWidth,
              n = t.clientHeight;
            if (!e && !n) return E;
            var r = j(t).getComputedStyle(t),
              a = (function (t) {
                for (var e = {}, n = 0, r = ['top', 'right', 'bottom', 'left']; n < r.length; n++) {
                  var a = r[n],
                    o = t['padding-' + a];
                  e[a] = M(o);
                }
                return e;
              })(r),
              o = a.left + a.right,
              i = a.top + a.bottom,
              s = M(r.width),
              h = M(r.height);
            if (
              ('border-box' === r.boxSizing &&
                (Math.round(s + o) !== e && (s -= P(r, 'left', 'right') + o), Math.round(h + i) !== n && (h -= P(r, 'top', 'bottom') + i)),
              !(function (t) {
                return t === j(t).document.documentElement;
              })(t))
            ) {
              var l = Math.round(s + o) - e,
                c = Math.round(h + i) - n;
              1 !== Math.abs(l) && (s -= l), 1 !== Math.abs(c) && (h -= c);
            }
            return I(a.left, a.top, s, h);
          }
          var D =
            'undefined' != typeof SVGGraphicsElement
              ? function (t) {
                  return t instanceof j(t).SVGGraphicsElement;
                }
              : function (t) {
                  return t instanceof j(t).SVGElement && 'function' == typeof t.getBBox;
                };
          function F(t) {
            return _
              ? D(t)
                ? (function (t) {
                    var e = t.getBBox();
                    return I(0, 0, e.width, e.height);
                  })(t)
                : B(t)
              : E;
          }
          function I(t, e, n, r) {
            return { x: t, y: e, width: n, height: r };
          }
          var H = (function () {
              function t(t) {
                (this.broadcastWidth = 0), (this.broadcastHeight = 0), (this.contentRect_ = I(0, 0, 0, 0)), (this.target = t);
              }
              return (
                (t.prototype.isActive = function () {
                  var t = F(this.target);
                  return (this.contentRect_ = t), t.width !== this.broadcastWidth || t.height !== this.broadcastHeight;
                }),
                (t.prototype.broadcastRect = function () {
                  var t = this.contentRect_;
                  return (this.broadcastWidth = t.width), (this.broadcastHeight = t.height), t;
                }),
                t
              );
            })(),
            W = function (t, e) {
              var n,
                r,
                a,
                o,
                i,
                s,
                h,
                l =
                  ((r = (n = e).x),
                  (a = n.y),
                  (o = n.width),
                  (i = n.height),
                  (s = 'undefined' != typeof DOMRectReadOnly ? DOMRectReadOnly : Object),
                  (h = Object.create(s.prototype)),
                  A(h, { x: r, y: a, width: o, height: i, top: a, right: r + o, bottom: i + a, left: r }),
                  h);
              A(this, { target: t, contentRect: l });
            },
            U = (function () {
              function t(t, e, n) {
                if (((this.activeObservations_ = []), (this.observations_ = new L()), 'function' != typeof t))
                  throw new TypeError('The callback provided as parameter 1 is not a function.');
                (this.callback_ = t), (this.controller_ = e), (this.callbackCtx_ = n);
              }
              return (
                (t.prototype.observe = function (t) {
                  if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
                  if ('undefined' != typeof Element && Element instanceof Object) {
                    if (!(t instanceof j(t).Element)) throw new TypeError('parameter 1 is not of type "Element".');
                    var e = this.observations_;
                    e.has(t) || (e.set(t, new H(t)), this.controller_.addObserver(this), this.controller_.refresh());
                  }
                }),
                (t.prototype.unobserve = function (t) {
                  if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
                  if ('undefined' != typeof Element && Element instanceof Object) {
                    if (!(t instanceof j(t).Element)) throw new TypeError('parameter 1 is not of type "Element".');
                    var e = this.observations_;
                    e.has(t) && (e.delete(t), e.size || this.controller_.removeObserver(this));
                  }
                }),
                (t.prototype.disconnect = function () {
                  this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
                }),
                (t.prototype.gatherActive = function () {
                  var t = this;
                  this.clearActive(),
                    this.observations_.forEach(function (e) {
                      e.isActive() && t.activeObservations_.push(e);
                    });
                }),
                (t.prototype.broadcastActive = function () {
                  if (this.hasActive()) {
                    var t = this.callbackCtx_,
                      e = this.activeObservations_.map(function (t) {
                        return new W(t.target, t.broadcastRect());
                      });
                    this.callback_.call(t, e, t), this.clearActive();
                  }
                }),
                (t.prototype.clearActive = function () {
                  this.activeObservations_.splice(0);
                }),
                (t.prototype.hasActive = function () {
                  return this.activeObservations_.length > 0;
                }),
                t
              );
            })(),
            K = 'undefined' != typeof WeakMap ? new WeakMap() : new L(),
            q = function t(e) {
              if (!(this instanceof t)) throw new TypeError('Cannot call a class as a function.');
              if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
              var n = O.getInstance(),
                r = new U(e, n, this);
              K.set(this, r);
            };
          ['observe', 'unobserve', 'disconnect'].forEach(function (t) {
            q.prototype[t] = function () {
              var e;
              return (e = K.get(this))[t].apply(e, arguments);
            };
          });
          var V,
            G = void 0 !== R.ResizeObserver ? R.ResizeObserver : q;
          (V = l(document.documentElement)), c() || d(V) || w(V);
          var Z = c(),
            J = class extends HTMLElement {
              constructor() {
                super(),
                  this.__registerHost(),
                  Object(e.b)(this),
                  (this.logoOnly = !1),
                  (this.fontLoading = !Z),
                  (this.buttonStyle = 'black'),
                  (this.type = 'buy');
              }
              checkStyle(t, e) {
                var n = Y(t, e);
                n !== t && this.element.setAttribute('buttonstyle', n);
              }
              checkType(t, e) {
                var n = X(t, e);
                n !== t && this.element.setAttribute('type', n),
                  this.metadata && (this.minButtonWidth = this.getMinButtonWidth(this.metadata));
              }
              verifyLocaleAndSwapMetadata(t) {
                (this._locale = this.adjustLocaleAndSetLangIfNecessary(t)),
                  Z || this.loadFontIfNecessary(this._locale),
                  (this.metadata = C[this._locale]),
                  (this.minButtonWidth = this.getMinButtonWidth(this.metadata));
              }
              componentWillLoad() {
                var t,
                  e = this;
                return ((t = function* () {
                  var t = Y(e.buttonStyle);
                  t !== e.buttonStyle && e.element.setAttribute('buttonstyle', t);
                  var n = X(e.type);
                  n !== e.type && e.element.setAttribute('type', n), e.verifyLocaleAndSwapMetadata(e.locale);
                }),
                function () {
                  var e = this,
                    n = arguments;
                  return new Promise(function (a, o) {
                    var i = t.apply(e, n);
                    function s(t) {
                      r(i, a, o, s, h, 'next', t);
                    }
                    function h(t) {
                      r(i, a, o, s, h, 'throw', t);
                    }
                    s(void 0);
                  });
                })();
              }
              componentDidRender() {
                this.validateFontSize(this.container.offsetWidth);
              }
              componentDidLoad() {
                new G((t, e) => {
                  for (var n of t) {
                    var { width: r } = n.contentRect;
                    if ('plain' === this.type) return;
                    this.validateFontSize(r);
                  }
                }).observe(this.container),
                  this.element.addEventListener('click', (t) => t.stopPropagation());
              }
              validateFontSize(t) {
                var e, n, r, a;
                'plain' !== this.type &&
                  (t < this.minButtonWidth
                    ? (null === (e = this.container.querySelector('#svg-text')) || void 0 === e || e.classList.add('hidden'),
                      null === (n = this.container.querySelector('#svg-logo')) || void 0 === n || n.classList.remove('hidden'))
                    : (null === (r = this.container.querySelector('#svg-text')) || void 0 === r || r.classList.remove('hidden'),
                      null === (a = this.container.querySelector('#svg-logo')) || void 0 === a || a.classList.add('hidden')));
              }
              getStyle(t) {
                return (
                  ':host(apple-pay-button){display:inline-block;' +
                  'min-width:'.concat('plain' === t ? '100px' : '140px', ';') +
                  'min-height:30px;' +
                  (Q() ? '' : 'display:none;') +
                  '}'
                );
              }
              loadFontIfNecessary(t) {
                try {
                  var e = document.fonts.check('15px apple-pay-btn-'.concat(t)),
                    n = d(t);
                  n || w(t),
                    (this.fontLoading = !n || !e),
                    this.fontLoading &&
                      document.fonts.ready.then(() =>
                        setTimeout(() => {
                          this.fontLoading = !1;
                        }, 0)
                      );
                } catch (t) {
                  this.fontLoading = !1;
                }
              }
              getMinButtonWidth(t) {
                var e = X(this.type),
                  { width: n, height: r } = (function (t, e) {
                    return 'plain' === e ? { width: 35, height: 15 } : { width: x({ metadata: t, buttonType: e }).width, height: 18 };
                  })(t, e);
                return (15 * n) / r;
              }
              adjustLocaleAndSetLangIfNecessary(t) {
                var e = (function (t) {
                  if (t) {
                    var e = h(i(t));
                    if (e) return e;
                  }
                })(t);
                if (e) {
                  e !== t && this.element.setAttribute('locale', e);
                  var n = e.replace('_', '-');
                  this.element.setAttribute('lang', n);
                } else this.element.removeAttribute('locale'), this.element.removeAttribute('lang'), (e = l(this.element));
                return e;
              }
              render() {
                var t = Y(this.buttonStyle),
                  n = X(this.type);
                return Object(e.c)(
                  e.a,
                  { 'aria-hidden': Q() ? void 0 : 'true' },
                  Object(e.c)(
                    'div',
                    {
                      class: 'apple-pay-btn-wrapper '.concat(n, ' ').concat(this._locale),
                      style: { visibility: this.fontLoading ? 'hidden' : 'visible' },
                    },
                    Object(e.c)('style', null, this.getStyle(n)),
                    Object(e.c)(
                      'button',
                      { 'aria-label': b(this.metadata, n), class: 'apple-pay-btn '.concat(t) },
                      Object(e.c)('span', {
                        ref: (t) => (this.container = t),
                        innerHTML: S({ metadata: this.metadata, locale: this._locale, buttonStyle: t, buttonType: n }),
                      })
                    )
                  )
                );
              }
              static get assetsDirs() {
                return ['assets/1.0.0'];
              }
              get element() {
                return this;
              }
              static get watchers() {
                return { buttonStyle: ['checkStyle'], type: ['checkType'], locale: ['verifyLocaleAndSwapMetadata'] };
              }
              static get style() {
                return '.apple-pay-btn-wrapper{width:100%;height:100%}.apple-pay-btn-wrapper.plain{min-width:100px}.plain .apple-pay-btn{--apple-pay-button-width-default:100px}.apple-pay-btn-wrapper .apple-pay-btn{background-color:black;border:none;color:white;cursor:pointer;font-synthesis:none;-ms-flex-pack:center;justify-content:center;position:relative;margin:0;-webkit-box-sizing:var(--apple-pay-button-box-sizing, content-box);box-sizing:var(--apple-pay-button-box-sizing, content-box);min-height:30px;height:calc(var(--apple-pay-button-height, 30px));min-width:var(--apple-pay-button-width-default, 140px);width:var(--apple-pay-button-width, auto);border-radius:var(--apple-pay-button-border-radius, 4px);padding:var(--apple-pay-button-padding, 0);-moz-font-feature-settings:kern;-moz-osx-font-smoothing:"grayscale";-webkit-font-smoothing:antialiased}.apple-pay-btn-wrapper .apple-pay-btn.white,.apple-pay-btn-wrapper .apple-pay-btn.white-outline{background-color:white;color:black}.apple-pay-btn-wrapper .apple-pay-btn.white-outline{border:1px solid black}.apple-pay-btn-wrapper .apple-pay-btn>span{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;height:100%}.apple-pay-btn-wrapper .apple-pay-btn>span>svg{max-width:100%;min-height:24px;min-width:50%;height:100%;-webkit-transform:translateZ(0) scale(1, 1);transform:translateZ(0) scale(1, 1)}.apple-pay-btn-wrapper .apple-pay-btn #svg-text.hidden,.apple-pay-btn-wrapper .apple-pay-btn #svg-logo.hidden{display:none}';
              }
            };
          function Y(t, e) {
            var n = ['black', 'white-outline', 'white'],
              r = t.trim();
            return n.includes(r) ? r : e && n.includes(e) ? e : 'black';
          }
          function X(t, e) {
            var n = t.trim();
            return f(n) ? n : e && f(e) ? e : 'buy';
          }
          function Q() {
            var t;
            try {
              return null === (t = window.ApplePaySession) || void 0 === t ? void 0 : t.canMakePayments();
            } catch (t) {
              return !1;
            }
          }
          var tt;
          'undefined' != typeof customElements &&
            [
              Object(e.d)(J, [
                1,
                'apple-pay-button',
                { buttonStyle: [513, 'buttonstyle'], type: [1537], locale: [1025], logoOnly: [32], fontLoading: [32] },
              ]),
            ].forEach((t) => {
              customElements.get(t.is) || customElements.define(t.is, t, tt);
            });
        }
        n.p = new URL(document.currentScript.src).origin + '/jsapi/v1';
        var o,
          i,
          s,
          h,
          l = !0;
        try {
          l = globalThis;
        } catch (t) {
          l = !1;
        }
        window.customElements && window.fetch && Symbol('desc').description && l
          ? a()
          : ((o = n.p + '/polyfills.js'),
            (i = a),
            (s = document.body),
            ((h = document.createElement('script')).src = o),
            (h.onload = i),
            (h.onreadystatechange = i),
            s.appendChild(h));
      }.call(this, n(44));
  },
  104: function (t, e) {
    function n(t) {
      return Promise.resolve().then(function () {
        var e = new Error("Cannot find module '" + t + "'");
        throw ((e.code = 'MODULE_NOT_FOUND'), e);
      });
    }
    (n.keys = function () {
      return [];
    }),
      (n.resolve = n),
      (t.exports = n),
      (n.id = 104);
  },
  14: function (t, e, n) {
    'use strict';
    n.d(e, 'a', function () {
      return Yt;
    }),
      n.d(e, 'b', function () {
        return qe;
      }),
      n.d(e, 'c', function () {
        return Zt;
      }),
      n.d(e, 'd', function () {
        return Ke;
      });
    var r,
      a,
      o,
      i,
      s = !1,
      h = !0,
      l = !1,
      c = !0,
      d = !0,
      w = !0,
      u = !0,
      p = !0,
      $ = !0,
      f = !0,
      m = !0,
      g = !0,
      b = !0,
      v = !0,
      y = !0,
      x = !1,
      k = !0,
      S = !0,
      C = !0,
      L = !0,
      _ = !0,
      R = !0,
      N = !0,
      T = !0,
      z = !0,
      O = !0,
      A = !0,
      j = !0,
      E = !0,
      M = !0,
      P = !0,
      B = !0,
      D = !0,
      F = !0,
      I = !0,
      H = !0,
      W = !0,
      U = !0,
      K = !0,
      q = !0,
      V = !0,
      G = !0,
      Z = !0,
      J = !0,
      Y = !1,
      X = !1,
      Q = !1,
      tt = !1,
      et = !1,
      nt = !1,
      rt = !1,
      at = !1,
      ot = !1,
      it = !0,
      st = !1,
      ht = !0,
      lt = !1,
      ct = !0,
      dt = !0,
      wt = !0,
      ut = !1,
      pt = !0,
      $t = !0,
      ft = !1,
      mt = !1,
      gt = !1,
      bt = !0;
    function vt(t, e, n, r, a, o, i) {
      try {
        var s = t[o](i),
          h = s.value;
      } catch (t) {
        return void n(t);
      }
      s.done ? e(h) : Promise.resolve(h).then(r, a);
    }
    function yt(t) {
      return function () {
        var e = this,
          n = arguments;
        return new Promise(function (r, a) {
          var o = t.apply(e, n);
          function i(t) {
            vt(o, r, a, i, s, 'next', t);
          }
          function s(t) {
            vt(o, r, a, i, s, 'throw', t);
          }
          i(void 0);
        });
      };
    }
    var xt = 0,
      kt = !1,
      St = !1,
      Ct = !1,
      Lt = !1,
      _t = 0,
      Rt = !1,
      Nt = 'undefined' != typeof window ? window : {},
      Tt = (ut && Nt.CSS, Nt.document || { head: {} }),
      zt =
        (Nt.HTMLElement,
        {
          $flags$: 0,
          $resourcesUrl$: '',
          jmp: (t) => t(),
          raf: (t) => requestAnimationFrame(t),
          ael: (t, e, n, r) => t.addEventListener(e, n, r),
          rel: (t, e, n, r) => t.removeEventListener(e, n, r),
          ce: (t, e) => new CustomEvent(t, e),
        }),
      Ot = !lt || !z || (() => (Tt.head.attachShadow + '').indexOf('[native') > -1)(),
      At = (() => {
        var t = !1;
        try {
          Tt.addEventListener(
            'e',
            null,
            Object.defineProperty({}, 'passive', {
              get() {
                t = !0;
              },
            })
          );
        } catch (t) {}
        return t;
      })(),
      jt =
        !!pt &&
        (() => {
          try {
            return new CSSStyleSheet(), 'function' == typeof new CSSStyleSheet().replace;
          } catch (t) {}
          return !1;
        })(),
      Et = (t, e, n, r) => {
        g &&
          n &&
          (x && (n = r ? n.filter(([t]) => 32 & t) : n.filter(([t]) => !(32 & t))),
          n.map(([n, r, a]) => {
            var o = k ? Pt(t, n) : t,
              i = Mt(e, a),
              s = Bt(n);
            zt.ael(o, r, i, s), (e.$rmListeners$ = e.$rmListeners$ || []).push(() => zt.rel(o, r, i, s));
          }));
      },
      Mt = (t, e) => (n) => {
        try {
          at
            ? 256 & t.$flags$
              ? t.$lazyInstance$[e](n)
              : (t.$queuedListeners$ = t.$queuedListeners$ || []).push([e, n])
            : t.$hostElement$[e](n);
        } catch (t) {
          Ye(t);
        }
      },
      Pt = (t, e) => (v && 4 & e ? Tt : b && 8 & e ? Nt : y && 16 & e ? Tt.body : x && 32 & e ? t.parentElement : t),
      Bt = (t) => (At ? { passive: 0 != (1 & t), capture: 0 != (2 & t) } : 0 != (2 & t)),
      Dt = 'http://www.w3.org/1999/xlink',
      Ft = (t, e = '') => {
        if (ot && performance.mark) {
          var n = 'st:'
            .concat(t, ':')
            .concat(e, ':')
            .concat(xt++);
          return performance.mark(n), () => performance.measure('[Stencil] '.concat(t, '() <').concat(e, '>'), n);
        }
        return () => {};
      },
      It = new WeakMap(),
      Ht = (t, e, n) => {
        var r = rn.get(t);
        jt && n ? (r = r || new CSSStyleSheet()).replace(e) : (r = e), rn.set(t, r);
      },
      Wt = (t, e, n, r) => {
        var a = Kt(e, n),
          o = rn.get(a);
        if (!bt) return a;
        if (((t = 11 === t.nodeType ? t : Tt), o))
          if ('string' == typeof o) {
            t = t.head || t;
            var i,
              s = It.get(t);
            if ((s || It.set(t, (s = new Set())), !s.has(a))) {
              if (nt && t.host && (i = t.querySelector('['.concat('sty-id', '="').concat(a, '"]')))) i.innerHTML = o;
              else {
                if (ut && zt.$cssShim$) {
                  var h = (i = zt.$cssShim$.createHostStyle(r, a, o, !!(10 & e.$flags$)))['s-sc'];
                  h && ((a = h), (s = null));
                } else (i = Tt.createElement('style')).innerHTML = o;
                (et || Y) && i.setAttribute('sty-id', a), t.insertBefore(i, t.querySelector('link'));
              }
              s && s.add(a);
            }
          } else pt && !t.adoptedStyleSheets.includes(o) && (t.adoptedStyleSheets = [...t.adoptedStyleSheets, o]);
        return a;
      },
      Ut = (t) => {
        var e = t.$cmpMeta$,
          n = t.$hostElement$,
          r = e.$flags$,
          a = Ft('attachStyles', e.$tagName$),
          o = Wt(z && Ot && n.shadowRoot ? n.shadowRoot : n.getRootNode(), e, t.$modeName$, n);
        (z || T) && A && 10 & r && ((n['s-sc'] = o), n.classList.add(o + '-h'), T && 2 & r && n.classList.add(o + '-s')), a();
      },
      Kt = (t, e) => 'sc-' + (L && e && 32 & t.$flags$ ? t.$tagName$ + '-' + e : t.$tagName$),
      qt = (t) => an.map((e) => e(t)).find((t) => !!t),
      Vt = {},
      Gt = (t) => 'object' === (t = typeof t) || 'function' === t,
      Zt = (t, e, ...n) => {
        var r = null,
          a = null,
          o = null,
          i = !1,
          s = !1,
          h = [],
          l = (e) => {
            for (var n = 0; n < e.length; n++)
              (r = e[n]),
                Array.isArray(r)
                  ? l(r)
                  : null != r &&
                    'boolean' != typeof r &&
                    ((i = 'function' != typeof t && !Gt(r))
                      ? (r = String(r))
                      : Q &&
                        'function' != typeof t &&
                        void 0 === r.$flags$ &&
                        Qe(
                          "vNode passed as children has unexpected type.\nMake sure it's using the correct h() function.\nEmpty objects can also be the cause, look for JSX comments that became objects."
                        ),
                    i && s ? (h[h.length - 1].$text$ += r) : h.push(i ? Jt(null, r) : r),
                    (s = i));
          };
        if ((l(n), e && (Q && 'input' === t && ne(e), H && e.key && (a = e.key), it && e.name && (o = e.name), F))) {
          var c = e.className || e.class;
          c &&
            (e.class =
              'object' != typeof c
                ? c
                : Object.keys(c)
                    .filter((t) => c[t])
                    .join(' '));
        }
        if (
          (Q &&
            h.some(Xt) &&
            Qe(
              "The <Host> must be the single root component. Make sure:\n- You are NOT using hostData() and <Host> in the same component.\n- <Host> is used once, and it's the single root component of the render() function."
            ),
          I && 'function' == typeof t)
        )
          return t(null === e ? {} : e, h, Qt);
        var d = Jt(t, null);
        return (d.$attrs$ = e), h.length > 0 && (d.$children$ = h), H && (d.$key$ = a), it && (d.$name$ = o), d;
      },
      Jt = (t, e) => {
        var n = { $flags$: 0, $tag$: t, $text$: e, $elm$: null, $children$: null };
        return B && (n.$attrs$ = null), H && (n.$key$ = null), it && (n.$name$ = null), n;
      },
      Yt = {},
      Xt = (t) => t && t.$tag$ === Yt,
      Qt = { forEach: (t, e) => t.map(te).forEach(e), map: (t, e) => t.map(te).map(e).map(ee) },
      te = (t) => ({ vattrs: t.$attrs$, vchildren: t.$children$, vkey: t.$key$, vname: t.$name$, vtag: t.$tag$, vtext: t.$text$ }),
      ee = (t) => {
        if ('function' == typeof t.vtag) {
          var e = Object.assign({}, t.vattrs);
          return t.vkey && (e.key = t.vkey), t.vname && (e.name = t.vname), Zt(t.vtag, e, ...(t.vchildren || []));
        }
        var n = Jt(t.vtag, t.vtext);
        return (n.$attrs$ = t.vattrs), (n.$children$ = t.vchildren), (n.$key$ = t.vkey), (n.$name$ = t.vname), n;
      },
      ne = (t) => {
        var e = Object.keys(t),
          n = e.indexOf('type'),
          r = e.indexOf('min'),
          a = e.indexOf('max'),
          o = e.indexOf('min'),
          i = e.indexOf('value');
        -1 !== i &&
          (i < n || i < r || i < a || i < o) &&
          tn('The "value" prop of <input> should be set after "min", "max", "type" and "step"');
      },
      re = (t, e, n, r, a, o) => {
        if (n !== r) {
          var i = Je(t, e),
            s = e.toLowerCase();
          if (F && 'class' === e) {
            var h = t.classList,
              l = oe(n),
              c = oe(r);
            h.remove(...l.filter((t) => t && !c.includes(t))), h.add(...c.filter((t) => t && !l.includes(t)));
          } else if (V && 'style' === e) {
            if (P) for (var d in n) (r && null != r[d]) || (!et && d.includes('-') ? t.style.removeProperty(d) : (t.style[d] = ''));
            for (var w in r) (n && r[w] === n[w]) || (!et && w.includes('-') ? t.style.setProperty(w, r[w]) : (t.style[w] = r[w]));
          } else if (H && 'key' === e);
          else if (U && 'ref' === e) r && r(t);
          else if (!W || (at ? i : t.__lookupSetter__(e)) || 'o' !== e[0] || 'n' !== e[1]) {
            if (K) {
              var u = Gt(r);
              if ((i || (u && null !== r)) && !a)
                try {
                  if (t.tagName.includes('-')) t[e] = r;
                  else {
                    var p = null == r ? '' : r;
                    'list' === e ? (i = !1) : (null != n && t[e] == p) || (t[e] = p);
                  }
                } catch (t) {}
              var $ = !1;
              D && s !== (s = s.replace(/^xlink\:?/, '')) && ((e = s), ($ = !0)),
                null == r || !1 === r
                  ? (!1 === r && '' !== t.getAttribute(e)) || (D && $ ? t.removeAttributeNS(Dt, e) : t.removeAttribute(e))
                  : (!i || 4 & o || a) && !u && ((r = !0 === r ? '' : r), D && $ ? t.setAttributeNS(Dt, e, r) : t.setAttribute(e, r));
            }
          } else
            (e = '-' === e[2] ? e.slice(3) : Je(Nt, s) ? s.slice(2) : s[2] + e.slice(3)),
              n && zt.rel(t, e, n, !1),
              r && zt.ael(t, e, r, !1);
        }
      },
      ae = /\s/,
      oe = (t) => (t ? t.split(ae) : []),
      ie = (t, e, n, r) => {
        var a = 11 === e.$elm$.nodeType && e.$elm$.host ? e.$elm$.host : e.$elm$,
          o = (t && t.$attrs$) || Vt,
          i = e.$attrs$ || Vt;
        if (P) for (r in o) r in i || re(a, r, o[r], void 0, n, e.$flags$);
        for (r in i) re(a, r, o[r], i[r], n, e.$flags$);
      },
      se = (t, e, n, i) => {
        var s,
          h,
          l,
          c = e.$children$[n],
          d = 0;
        if (
          (it && !kt && ((Ct = !0), 'slot' === c.$tag$ && (r && i.classList.add(r + '-s'), (c.$flags$ |= c.$children$ ? 2 : 1))),
          Q &&
            c.$elm$ &&
            Qe(
              'The JSX '.concat(
                null !== c.$text$ ? '"'.concat(c.$text$, '" text') : '"'.concat(c.$tag$, '" element'),
                ' node should not be shared within the same renderer. The renderer caches element lookups in order to improve performance. However, a side effect from this is that the exact same JSX node should not be reused. For more information please see https://stenciljs.com/docs/templating-jsx#avoid-shared-jsx-nodes'
              )
            ),
          G && null !== c.$text$)
        )
          s = c.$elm$ = Tt.createTextNode(c.$text$);
        else if (it && 1 & c.$flags$) s = c.$elm$ = X || et ? ye(c) : Tt.createTextNode('');
        else {
          if (
            (M && !Lt && (Lt = 'svg' === c.$tag$),
            (s = c.$elm$ =
              M
                ? Tt.createElementNS(
                    Lt ? 'http://www.w3.org/2000/svg' : 'http://www.w3.org/1999/xhtml',
                    it && 2 & c.$flags$ ? 'slot-fb' : c.$tag$
                  )
                : Tt.createElement(it && 2 & c.$flags$ ? 'slot-fb' : c.$tag$)),
            M && Lt && 'foreignObject' === c.$tag$ && (Lt = !1),
            B && ie(null, c, Lt),
            (z || T) && null != r && s['s-si'] !== r && s.classList.add((s['s-si'] = r)),
            c.$children$)
          )
            for (d = 0; d < c.$children$.length; ++d) (h = se(t, c, d, s)) && s.appendChild(h);
          M && ('svg' === c.$tag$ ? (Lt = !1) : 'foreignObject' === s.tagName && (Lt = !0));
        }
        return (
          it &&
            ((s['s-hn'] = o),
            3 & c.$flags$ &&
              ((s['s-sr'] = !0),
              (s['s-cr'] = a),
              (s['s-sn'] = c.$name$ || ''),
              (l = t && t.$children$ && t.$children$[n]) && l.$tag$ === c.$tag$ && t.$elm$ && he(t.$elm$, !1))),
          s
        );
      },
      he = (t, e) => {
        zt.$flags$ |= 1;
        for (var n = t.childNodes, r = n.length - 1; r >= 0; r--) {
          var a = n[r];
          a['s-hn'] !== o && a['s-ol'] && (ue(a).insertBefore(a, we(a)), a['s-ol'].remove(), (a['s-ol'] = void 0), (Ct = !0)),
            e && he(a, e);
        }
        zt.$flags$ &= -2;
      },
      le = (t, e, n, r, a, i) => {
        var s,
          h = (it && t['s-cr'] && t['s-cr'].parentNode) || t;
        for (z && h.shadowRoot && h.tagName === o && (h = h.shadowRoot); a <= i; ++a)
          r[a] && (s = se(null, n, a, t)) && ((r[a].$elm$ = s), h.insertBefore(s, it ? we(e) : e));
      },
      ce = (t, e, n, r, a) => {
        for (; e <= n; ++e) (r = t[e]) && ((a = r.$elm$), be(r), it && ((St = !0), a['s-ol'] ? a['s-ol'].remove() : he(a, !0)), a.remove());
      },
      de = (t, e) => t.$tag$ === e.$tag$ && (it && 'slot' === t.$tag$ ? t.$name$ === e.$name$ : !H || t.$key$ === e.$key$),
      we = (t) => (t && t['s-ol']) || t,
      ue = (t) => (t['s-ol'] ? t['s-ol'] : t).parentNode,
      pe = (t, e) => {
        var n,
          r = (e.$elm$ = t.$elm$),
          a = t.$children$,
          o = e.$children$,
          i = e.$tag$,
          s = e.$text$;
        G && null !== s
          ? G && it && (n = r['s-cr'])
            ? (n.parentNode.textContent = s)
            : G && t.$text$ !== s && (r.data = s)
          : (M && (Lt = 'svg' === i || ('foreignObject' !== i && Lt)),
            (B || N) && ((O && 'slot' === i) || ie(t, e, Lt)),
            P && null !== a && null !== o
              ? ((t, e, n, r) => {
                  for (
                    var a, o, i = 0, s = 0, h = 0, l = 0, c = e.length - 1, d = e[0], w = e[c], u = r.length - 1, p = r[0], $ = r[u];
                    i <= c && s <= u;

                  )
                    if (null == d) d = e[++i];
                    else if (null == w) w = e[--c];
                    else if (null == p) p = r[++s];
                    else if (null == $) $ = r[--u];
                    else if (de(d, p)) pe(d, p), (d = e[++i]), (p = r[++s]);
                    else if (de(w, $)) pe(w, $), (w = e[--c]), ($ = r[--u]);
                    else if (de(d, $))
                      !it || ('slot' !== d.$tag$ && 'slot' !== $.$tag$) || he(d.$elm$.parentNode, !1),
                        pe(d, $),
                        t.insertBefore(d.$elm$, w.$elm$.nextSibling),
                        (d = e[++i]),
                        ($ = r[--u]);
                    else if (de(w, p))
                      !it || ('slot' !== d.$tag$ && 'slot' !== $.$tag$) || he(w.$elm$.parentNode, !1),
                        pe(w, p),
                        t.insertBefore(w.$elm$, d.$elm$),
                        (w = e[--c]),
                        (p = r[++s]);
                    else {
                      if (((h = -1), H))
                        for (l = i; l <= c; ++l)
                          if (e[l] && null !== e[l].$key$ && e[l].$key$ === p.$key$) {
                            h = l;
                            break;
                          }
                      H && h >= 0
                        ? ((o = e[h]).$tag$ !== p.$tag$ ? (a = se(e && e[s], n, h, t)) : (pe(o, p), (e[h] = void 0), (a = o.$elm$)),
                          (p = r[++s]))
                        : ((a = se(e && e[s], n, s, t)), (p = r[++s])),
                        a && (it ? ue(d.$elm$).insertBefore(a, we(d.$elm$)) : d.$elm$.parentNode.insertBefore(a, d.$elm$));
                    }
                  i > c ? le(t, null == r[u + 1] ? null : r[u + 1].$elm$, n, r, s, u) : P && s > u && ce(e, i, c);
                })(r, a, e, o)
              : null !== o
              ? (P && G && null !== t.$text$ && (r.textContent = ''), le(r, null, e, o, 0, o.length - 1))
              : P && null !== a && ce(a, 0, a.length - 1),
            M && Lt && 'svg' === i && (Lt = !1));
      },
      $e = (t) => {
        var e,
          n,
          r,
          a,
          o,
          i,
          s = t.childNodes;
        for (n = 0, r = s.length; n < r; n++)
          if (1 === (e = s[n]).nodeType) {
            if (e['s-sr'])
              for (o = e['s-sn'], e.hidden = !1, a = 0; a < r; a++)
                if (((i = s[a].nodeType), s[a]['s-hn'] !== e['s-hn'] || '' !== o)) {
                  if (1 === i && o === s[a].getAttribute('slot')) {
                    e.hidden = !0;
                    break;
                  }
                } else if (1 === i || (3 === i && '' !== s[a].textContent.trim())) {
                  e.hidden = !0;
                  break;
                }
            $e(e);
          }
      },
      fe = [],
      me = (t) => {
        for (var e, n, r, a, o, i, s = 0, h = t.childNodes, l = h.length; s < l; s++) {
          if ((e = h[s])['s-sr'] && (n = e['s-cr']) && n.parentNode)
            for (r = n.parentNode.childNodes, a = e['s-sn'], i = r.length - 1; i >= 0; i--)
              (n = r[i])['s-cn'] ||
                n['s-nr'] ||
                n['s-hn'] === e['s-hn'] ||
                (ge(n, a)
                  ? ((o = fe.find((t) => t.$nodeToRelocate$ === n)),
                    (St = !0),
                    (n['s-sn'] = n['s-sn'] || a),
                    o ? (o.$slotRefNode$ = e) : fe.push({ $slotRefNode$: e, $nodeToRelocate$: n }),
                    n['s-sr'] &&
                      fe.map((t) => {
                        ge(t.$nodeToRelocate$, n['s-sn']) &&
                          (o = fe.find((t) => t.$nodeToRelocate$ === n)) &&
                          !t.$slotRefNode$ &&
                          (t.$slotRefNode$ = o.$slotRefNode$);
                      }))
                  : fe.some((t) => t.$nodeToRelocate$ === n) || fe.push({ $nodeToRelocate$: n }));
          1 === e.nodeType && me(e);
        }
      },
      ge = (t, e) =>
        1 === t.nodeType ? (null === t.getAttribute('slot') && '' === e) || t.getAttribute('slot') === e : t['s-sn'] === e || '' === e,
      be = (t) => {
        U && (t.$attrs$ && t.$attrs$.ref && t.$attrs$.ref(null), t.$children$ && t.$children$.map(be));
      },
      ve = (t, e) => {
        var n = t.$hostElement$,
          i = t.$cmpMeta$,
          s = t.$vnode$ || Jt(null, null),
          h = Xt(e) ? e : Zt(null, null, e);
        if (((o = n.tagName), Q && Array.isArray(e) && e.some(Xt)))
          throw new Error(
            'The <Host> must be the single root component.\nLooks like the render() function of "'.concat(
              o.toLowerCase(),
              '" is returning an array that contains the <Host>.\n\nThe render() function should look like this instead:\n\nrender() {\n  // Do not return an array\n  return (\n    <Host>{content}</Host>\n  );\n}\n  '
            )
          );
        if (
          (N && i.$attrsToReflect$ && ((h.$attrs$ = h.$attrs$ || {}), i.$attrsToReflect$.map(([t, e]) => (h.$attrs$[e] = n[t]))),
          (h.$tag$ = null),
          (h.$flags$ |= 4),
          (t.$vnode$ = h),
          (h.$elm$ = s.$elm$ = (z && n.shadowRoot) || n),
          (T || z) && (r = n['s-sc']),
          it && ((a = n['s-cr']), (kt = Ot && 0 != (1 & i.$flags$)), (St = !1)),
          pe(s, h),
          it)
        ) {
          if (((zt.$flags$ |= 1), Ct)) {
            var l, c, d, w, u, p;
            me(h.$elm$);
            for (var $ = 0; $ < fe.length; $++)
              (c = (l = fe[$]).$nodeToRelocate$)['s-ol'] ||
                (((d = X || et ? xe(c) : Tt.createTextNode(''))['s-nr'] = c), c.parentNode.insertBefore((c['s-ol'] = d), c));
            for ($ = 0; $ < fe.length; $++)
              if (((c = (l = fe[$]).$nodeToRelocate$), l.$slotRefNode$)) {
                for (w = l.$slotRefNode$.parentNode, u = l.$slotRefNode$.nextSibling, d = c['s-ol']; (d = d.previousSibling); )
                  if ((p = d['s-nr']) && p['s-sn'] === c['s-sn'] && w === p.parentNode && (!(p = p.nextSibling) || !p['s-nr'])) {
                    u = p;
                    break;
                  }
                ((!u && w !== c.parentNode) || c.nextSibling !== u) &&
                  c !== u &&
                  (!c['s-hn'] && c['s-ol'] && (c['s-hn'] = c['s-ol'].parentNode.nodeName), w.insertBefore(c, u));
              } else 1 === c.nodeType && (c.hidden = !0);
          }
          St && $e(h.$elm$), (zt.$flags$ &= -2), (fe.length = 0);
        }
      },
      ye = (t) => Tt.createComment('<slot'.concat(t.$name$ ? ' name="' + t.$name$ + '"' : '', '> (host=').concat(o.toLowerCase(), ')')),
      xe = (t) =>
        Tt.createComment(
          'org-location for ' + (t.localName ? '<'.concat(t.localName, '> (host=').concat(t['s-hn'], ')') : '['.concat(t.textContent, ']'))
        ),
      ke = (t, e, n) => {
        var r = zt.ce(e, n);
        return t.dispatchEvent(r), r;
      },
      Se = (t, e) => {
        mt && e && !t.$onRenderResolve$ && e['s-p'] && e['s-p'].push(new Promise((e) => (t.$onRenderResolve$ = e)));
      },
      Ce = (t, e) => {
        if ((J && P && (t.$flags$ |= 16), !(mt && 4 & t.$flags$))) {
          Se(t, t.$ancestorComponent$);
          var n = () => Le(t, e);
          return J ? pn(n) : n();
        }
        t.$flags$ |= 512;
      },
      Le = (t, e) => {
        var n,
          r = t.$hostElement$,
          a = Ft('scheduleUpdate', t.$cmpMeta$.$tagName$),
          o = at ? t.$lazyInstance$ : r;
        return (
          e
            ? (at &&
                g &&
                ((t.$flags$ |= 256),
                t.$queuedListeners$ && (t.$queuedListeners$.map(([t, e]) => ze(o, t, e)), (t.$queuedListeners$ = null))),
              Ae(r, 'componentWillLoad'),
              w && (n = ze(o, 'componentWillLoad')))
            : (Ae(r, 'componentWillUpdate'), u && (n = ze(o, 'componentWillUpdate'))),
          Ae(r, 'componentWillRender'),
          p && (n = Oe(n, () => ze(o, 'componentWillRender'))),
          a(),
          Oe(n, () => _e(t, o, e))
        );
      },
      _e = (function () {
        var t = yt(function* (t, e, n) {
          var r = t.$hostElement$,
            a = Ft('update', t.$cmpMeta$.$tagName$),
            o = r['s-rc'];
          E && n && Ut(t);
          var i = Ft('render', t.$cmpMeta$.$tagName$);
          if (
            (Q && (t.$flags$ |= 1024),
            et ? yield Re(t, e, r) : Re(t, e, r),
            ut && zt.$cssShim$ && zt.$cssShim$.updateHost(r),
            Q && (t.$renderCount$++, (t.$flags$ &= -1025)),
            et)
          )
            try {
              Ee(r), n && (1 & t.$cmpMeta$.$flags$ ? (r['s-en'] = '') : 2 & t.$cmpMeta$.$flags$ && (r['s-en'] = 'c'));
            } catch (t) {
              Ye(t, r);
            }
          if ((mt && o && (o.map((t) => t()), (r['s-rc'] = void 0)), i(), a(), mt)) {
            var s = r['s-p'],
              h = () => Ne(t);
            0 === s.length ? h() : (Promise.all(s).then(h), (t.$flags$ |= 4), (s.length = 0));
          } else Ne(t);
        });
        return function (e, n, r) {
          return t.apply(this, arguments);
        };
      })(),
      Re = (t, e, n) => {
        var r = !!s,
          a = !!at,
          o = !!J,
          i = !!P;
        try {
          if ((e, (e = (r || e.render) && e.render()), i && o && (t.$flags$ &= -17), (i || a) && (t.$flags$ |= 2), m || N))
            if (q || N) {
              if (et) return Promise.resolve(e).then((e) => ve(t, e));
              ve(t, e);
            } else n.textContent = e;
        } catch (e) {
          Ye(e, t.$hostElement$);
        }
        return null, null;
      },
      Ne = (t) => {
        var e = t.$cmpMeta$.$tagName$,
          n = t.$hostElement$,
          r = Ft('postUpdate', e),
          a = at ? t.$lazyInstance$ : n,
          o = t.$ancestorComponent$;
        d && (Q && (t.$flags$ |= 1024), ze(a, 'componentDidRender'), Q && (t.$flags$ &= -1025)),
          Ae(n, 'componentDidRender'),
          64 & t.$flags$
            ? (c && (Q && (t.$flags$ |= 1024), ze(a, 'componentDidUpdate'), Q && (t.$flags$ &= -1025)), Ae(n, 'componentDidUpdate'), r())
            : ((t.$flags$ |= 64),
              mt && A && je(n),
              h && (Q && (t.$flags$ |= 2048), ze(a, 'componentDidLoad'), Q && (t.$flags$ &= -2049)),
              Ae(n, 'componentDidLoad'),
              r(),
              mt && (t.$onReadyResolve$(n), o || Te(e))),
          Y && n['s-hmr-load'] && n['s-hmr-load'](),
          C && at && t.$onInstanceResolve$(n),
          mt &&
            (t.$onRenderResolve$ && (t.$onRenderResolve$(), (t.$onRenderResolve$ = void 0)),
            512 & t.$flags$ && un(() => Ce(t, !1)),
            (t.$flags$ &= -517));
      },
      Te = (t) => {
        A && je(Tt.documentElement),
          gt && (zt.$flags$ |= 2),
          un(() => ke(Nt, 'appload', { detail: { namespace: 'app' } })),
          ot && performance.measure && performance.measure('[Stencil] '.concat('app', ' initial load (by ').concat(t, ')'), 'st:app:start');
      },
      ze = (t, e, n) => {
        if (t && t[e])
          try {
            return t[e](n);
          } catch (t) {
            Ye(t);
          }
      },
      Oe = (t, e) => (t && t.then ? t.then(e) : e()),
      Ae = (t, e) => {
        rt && ke(t, 'stencil_' + e, { bubbles: !0, composed: !0, detail: { namespace: 'app' } });
      },
      je = (t) => (ht ? t.classList.add('hydrated') : st ? t.setAttribute('hydrated', '') : void 0),
      Ee = (t) => {
        var e = t.children;
        if (null != e)
          for (var n = 0, r = e.length; n < r; n++) {
            var a = e[n];
            'function' == typeof a.connectedCallback && a.connectedCallback(), Ee(a);
          }
      },
      Me = (t, e, n, r, a, o, i) => {
        var s, h, l, c;
        if (1 === o.nodeType) {
          for (
            (s = o.getAttribute('c-id')) &&
              (((h = s.split('.'))[0] !== i && '0' !== h[0]) ||
                ((l = {
                  $flags$: 0,
                  $hostId$: h[0],
                  $nodeId$: h[1],
                  $depth$: h[2],
                  $index$: h[3],
                  $tag$: o.tagName.toLowerCase(),
                  $elm$: o,
                  $attrs$: null,
                  $children$: null,
                  $key$: null,
                  $name$: null,
                  $text$: null,
                }),
                e.push(l),
                o.removeAttribute('c-id'),
                t.$children$ || (t.$children$ = []),
                (t.$children$[l.$index$] = l),
                (t = l),
                r && '0' === l.$depth$ && (r[l.$index$] = l.$elm$))),
              c = o.childNodes.length - 1;
            c >= 0;
            c--
          )
            Me(t, e, n, r, a, o.childNodes[c], i);
          if (o.shadowRoot) for (c = o.shadowRoot.childNodes.length - 1; c >= 0; c--) Me(t, e, n, r, a, o.shadowRoot.childNodes[c], i);
        } else if (8 === o.nodeType)
          ((h = o.nodeValue.split('.'))[1] !== i && '0' !== h[1]) ||
            ((s = h[0]),
            (l = {
              $flags$: 0,
              $hostId$: h[1],
              $nodeId$: h[2],
              $depth$: h[3],
              $index$: h[4],
              $elm$: o,
              $attrs$: null,
              $children$: null,
              $key$: null,
              $name$: null,
              $tag$: null,
              $text$: null,
            }),
            't' === s
              ? ((l.$elm$ = o.nextSibling),
                l.$elm$ &&
                  3 === l.$elm$.nodeType &&
                  ((l.$text$ = l.$elm$.textContent),
                  e.push(l),
                  o.remove(),
                  t.$children$ || (t.$children$ = []),
                  (t.$children$[l.$index$] = l),
                  r && '0' === l.$depth$ && (r[l.$index$] = l.$elm$)))
              : l.$hostId$ === i &&
                ('s' === s
                  ? ((l.$tag$ = 'slot'),
                    h[5] ? (o['s-sn'] = l.$name$ = h[5]) : (o['s-sn'] = ''),
                    (o['s-sr'] = !0),
                    z &&
                      r &&
                      ((l.$elm$ = Tt.createElement(l.$tag$)),
                      l.$name$ && l.$elm$.setAttribute('name', l.$name$),
                      o.parentNode.insertBefore(l.$elm$, o),
                      o.remove(),
                      '0' === l.$depth$ && (r[l.$index$] = l.$elm$)),
                    n.push(l),
                    t.$children$ || (t.$children$ = []),
                    (t.$children$[l.$index$] = l))
                  : 'r' === s && (z && r ? o.remove() : it && ((a['s-cr'] = o), (o['s-cn'] = !0)))));
        else if (t && 'style' === t.$tag$) {
          var d = Jt(null, o.textContent);
          (d.$elm$ = o), (d.$index$ = '0'), (t.$children$ = [d]);
        }
      },
      Pe = (t, e) => {
        if (1 === t.nodeType) {
          for (var n = 0; n < t.childNodes.length; n++) Pe(t.childNodes[n], e);
          if (t.shadowRoot) for (n = 0; n < t.shadowRoot.childNodes.length; n++) Pe(t.shadowRoot.childNodes[n], e);
        } else if (8 === t.nodeType) {
          var r = t.nodeValue.split('.');
          'o' === r[0] && (e.set(r[1] + '.' + r[2], t), (t.nodeValue = ''), (t['s-en'] = r[3]));
        }
      },
      Be = (t, e, n, r) => {
        var a,
          o,
          i = Ge(t),
          s = at ? i.$hostElement$ : t,
          h = i.$instanceValues$.get(e),
          l = i.$flags$,
          c = at ? i.$lazyInstance$ : s;
        if (
          ((a = n),
          (o = r.$members$[e][0]),
          (n =
            null == a || Gt(a)
              ? a
              : ct && 4 & o
              ? 'false' !== a && ('' === a || !!a)
              : dt && 2 & o
              ? parseFloat(a)
              : wt && 1 & o
              ? String(a)
              : a),
          !((at && 8 & l && void 0 !== h) || n === h) &&
            (i.$instanceValues$.set(e, n),
            Q &&
              (1024 & i.$flags$
                ? tn(
                    'The state/prop "'.concat(e, '" changed during rendering. This can potentially lead to infinite-loops and other bugs.'),
                    '\nElement',
                    s,
                    '\nNew value',
                    n,
                    '\nOld value',
                    h
                  )
                : 2048 & i.$flags$ &&
                  tn(
                    'The state/prop "'.concat(
                      e,
                      '" changed during "componentDidLoad()", this triggers extra re-renders, try to setup on "componentWillLoad()"'
                    ),
                    '\nElement',
                    s,
                    '\nNew value',
                    n,
                    '\nOld value',
                    h
                  )),
            !at || c))
        ) {
          if (Z && r.$watchers$ && 128 & l) {
            var d = r.$watchers$[e];
            d &&
              d.map((t) => {
                try {
                  c[t](n, h, e);
                } catch (t) {
                  Ye(t, s);
                }
              });
          }
          if (P && 2 == (18 & l)) {
            if ($t && c.componentShouldUpdate && !1 === c.componentShouldUpdate(n, h, e)) return;
            Ce(i, !1);
          }
        }
      },
      De = (t, e, n) => {
        if (S && e.$members$) {
          Z && t.watchers && (e.$watchers$ = t.watchers);
          var r = Object.entries(e.$members$),
            a = t.prototype;
          if (
            (r.map(([t, [r]]) => {
              (R || j) && (31 & r || ((!at || 2 & n) && 32 & r))
                ? Object.defineProperty(a, t, {
                    get() {
                      return (e = t), Ge(this).$instanceValues$.get(e);
                      var e;
                    },
                    set(a) {
                      if (Q) {
                        var o = Ge(this);
                        0 == (1 & n) &&
                          0 == (8 & o.$flags$) &&
                          0 != (31 & r) &&
                          0 == (1024 & r) &&
                          tn(
                            '@Prop() "'
                              .concat(t, '" on <')
                              .concat(
                                e.$tagName$,
                                '> is immutable but was modified from within the component.\nMore information: https://stenciljs.com/docs/properties#prop-mutability'
                              )
                          );
                      }
                      Be(this, t, a, e);
                    },
                    configurable: !0,
                    enumerable: !0,
                  })
                : at &&
                  C &&
                  1 & n &&
                  64 & r &&
                  Object.defineProperty(a, t, {
                    value(...e) {
                      var n = Ge(this);
                      return n.$onInstancePromise$.then(() => n.$lazyInstance$[t](...e));
                    },
                  });
            }),
            _ && (!at || 1 & n))
          ) {
            var o = new Map();
            (a.attributeChangedCallback = function (t, e, n) {
              zt.jmp(() => {
                var e = o.get(t);
                this[e] = (null !== n || 'boolean' != typeof this[e]) && n;
              });
            }),
              (t.observedAttributes = r
                .filter(([t, e]) => 15 & e[0])
                .map(([t, n]) => {
                  var r = n[1] || t;
                  return o.set(r, t), N && 512 & n[0] && e.$attrsToReflect$.push([t, r]), r;
                }));
          }
        }
        return t;
      },
      Fe = (function () {
        var t = yt(function* (t, e, r, a, o) {
          if ((at || et || E) && 0 == (32 & e.$flags$)) {
            if (at || nt) {
              if (((e.$flags$ |= 32), (o = nn(r, e, a)).then)) {
                var i =
                  ((d = 'st:load:'.concat(r.$tagName$, ':').concat(e.$modeName$)),
                  (w = '[Stencil] Load module for <'.concat(r.$tagName$, '>')),
                  ot && performance.mark
                    ? (0 === performance.getEntriesByName(d).length && performance.mark(d),
                      () => {
                        0 === performance.getEntriesByName(w).length && performance.measure(w, d);
                      })
                    : () => {});
                (o = yield o), i();
              }
              if ((Q || X) && !o) throw new Error('Constructor for "'.concat(r.$tagName$, '#').concat(e.$modeName$, '" was not found'));
              S && !o.isProxied && (Z && (r.$watchers$ = o.watchers), De(o, r, 2), (o.isProxied = !0));
              var s = Ft('createInstance', r.$tagName$);
              S && (e.$flags$ |= 8);
              try {
                new o(e);
              } catch (t) {
                Ye(t);
              }
              S && (e.$flags$ &= -9), Z && (e.$flags$ |= 128), s(), Ie(e.$lazyInstance$);
            } else (o = t.constructor), (e.$flags$ |= 160);
            if (E && o.style) {
              var h = o.style;
              L && 'string' != typeof h && ((h = h[(e.$modeName$ = qt(t))]), et && e.$modeName$ && t.setAttribute('s-mode', e.$modeName$));
              var l = Kt(r, e.$modeName$);
              if (!rn.has(l)) {
                var c = Ft('registerStyles', r.$tagName$);
                !et &&
                  z &&
                  lt &&
                  8 & r.$flags$ &&
                  (h = yield n
                    .e(2)
                    .then(n.bind(null, 195))
                    .then((t) => t.scopeCss(h, l, !1))),
                  Ht(l, h, !!(1 & r.$flags$)),
                  c();
              }
            }
          }
          var d,
            w,
            u = e.$ancestorComponent$,
            p = () => Ce(e, !0);
          mt && u && u['s-rc'] ? u['s-rc'].push(p) : p();
        });
        return function (e, n, r, a, o) {
          return t.apply(this, arguments);
        };
      })(),
      Ie = (t) => {
        at && $ && ze(t, 'connectedCallback');
      },
      He = (t) => {
        if (0 == (1 & zt.$flags$)) {
          var e = Ge(t),
            n = e.$cmpMeta$,
            r = Ft('connectedCallback', n.$tagName$);
          if ((x && Et(t, e, n.$listeners$, !0), 1 & e.$flags$)) Et(t, e, n.$listeners$, !1), Ie(e.$lazyInstance$);
          else {
            var a;
            if (((e.$flags$ |= 1), nt && (a = t.getAttribute('s-id')))) {
              if (z && Ot && 1 & n.$flags$) {
                var o = L ? Wt(t.shadowRoot, n, t.getAttribute('s-mode')) : Wt(t.shadowRoot, n);
                t.classList.remove(o + '-h', o + '-s');
              }
              ((t, e, n, r) => {
                var a = Ft('hydrateClient', e),
                  o = t.shadowRoot,
                  i = [],
                  s = z && o ? [] : null,
                  h = (r.$vnode$ = Jt(e, null));
                zt.$orgLocNodes$ || Pe(Tt.body, (zt.$orgLocNodes$ = new Map())),
                  (t['s-id'] = n),
                  t.removeAttribute('s-id'),
                  Me(h, i, [], s, t, t, n),
                  i.map((t) => {
                    var n = t.$hostId$ + '.' + t.$nodeId$,
                      r = zt.$orgLocNodes$.get(n),
                      a = t.$elm$;
                    r && Ot && '' === r['s-en'] && r.parentNode.insertBefore(a, r.nextSibling),
                      o || ((a['s-hn'] = e), r && ((a['s-ol'] = r), (a['s-ol']['s-nr'] = a))),
                      zt.$orgLocNodes$.delete(n);
                  }),
                  z &&
                    o &&
                    s.map((t) => {
                      t && o.appendChild(t);
                    }),
                  a();
              })(t, n.$tagName$, a, e);
            }
            if ((it && !a && (et || ((O || z) && 12 & n.$flags$)) && We(t), mt))
              for (var i = t; (i = i.parentNode || i.host); )
                if ((nt && 1 === i.nodeType && i.hasAttribute('s-id') && i['s-p']) || i['s-p']) {
                  Se(e, (e.$ancestorComponent$ = i));
                  break;
                }
            R &&
              at &&
              !et &&
              n.$members$ &&
              Object.entries(n.$members$).map(([e, [n]]) => {
                if (31 & n && t.hasOwnProperty(e)) {
                  var r = t[e];
                  delete t[e], (t[e] = r);
                }
              }),
              ft ? un(() => Fe(t, e, n)) : Fe(t, e, n);
          }
          r();
        }
      },
      We = (t) => {
        var e = (t['s-cr'] = Tt.createComment(X ? 'content-ref (host='.concat(t.localName, ')') : ''));
        (e['s-cn'] = !0), t.insertBefore(e, t.firstChild);
      },
      Ue = (t) => {
        if (0 == (1 & zt.$flags$)) {
          var e = Ge(t),
            n = at ? e.$lazyInstance$ : t;
          g && e.$rmListeners$ && (e.$rmListeners$.map((t) => t()), (e.$rmListeners$ = void 0)),
            ut && zt.$cssShim$ && zt.$cssShim$.removeHost(t),
            at && f && ze(n, 'disconnectedCallback'),
            l && ze(n, 'componentDidUnload');
        }
      },
      Ke = (t, e) => {
        var n = { $flags$: e[0], $tagName$: e[1] };
        S && (n.$members$ = e[2]),
          g && (n.$listeners$ = e[3]),
          Z && (n.$watchers$ = t.$watchers$),
          N && (n.$attrsToReflect$ = []),
          z && !Ot && 1 & n.$flags$ && (n.$flags$ |= 8);
        var r = t.prototype.connectedCallback,
          a = t.prototype.disconnectedCallback;
        return (
          Object.assign(t.prototype, {
            __registerHost() {
              Ze(this, n);
            },
            connectedCallback() {
              He(this), $ && r && r.call(this);
            },
            disconnectedCallback() {
              Ue(this), f && a && a.call(this);
            },
          }),
          (t.is = n.$tagName$),
          De(t, n, 3)
        );
      },
      qe = (t) => {
        Ot ? t.attachShadow({ mode: 'open' }) : (t.shadowRoot = t);
      },
      Ve = new WeakMap(),
      Ge = (t) => Ve.get(t),
      Ze = (t, e) => {
        var n = { $flags$: 0, $hostElement$: t, $cmpMeta$: e, $instanceValues$: new Map() };
        return (
          Q && (n.$renderCount$ = 0),
          C && at && (n.$onInstancePromise$ = new Promise((t) => (n.$onInstanceResolve$ = t))),
          mt && ((n.$onReadyPromise$ = new Promise((t) => (n.$onReadyResolve$ = t))), (t['s-p'] = []), (t['s-rc'] = [])),
          Et(t, n, e.$listeners$, !1),
          Ve.set(t, n)
        );
      },
      Je = (t, e) => e in t,
      Ye = (t, e) => (i || console.error)(t, e),
      Xe = tt
        ? ['STENCIL:']
        : ['%cstencil', 'color: white;background:#4c47ff;font-weight: bold; font-size:10px; padding:2px 6px; border-radius: 5px'],
      Qe = (...t) => console.error(...Xe, ...t),
      tn = (...t) => console.warn(...Xe, ...t),
      en = new Map(),
      nn = (t, e, r) => {
        var a = t.$tagName$.replace(/-/g, '_'),
          o = t.$lazyBundleId$;
        if (!Q || 'string' == typeof o) {
          var i = !Y && en.get(o);
          return i
            ? i[a]
            : n(104)('./'.concat(o, '.entry.js').concat(BUILD.hotModuleReplacement && r ? '?s-hmr=' + r : '')).then(
                (t) => (Y || en.set(o, t), t[a]),
                Ye
              );
        }
        Qe(
          'Trying to lazily load component <'.concat(t.$tagName$, '> with style mode "').concat(e.$modeName$, '", but it does not exist.')
        );
      },
      rn = new Map(),
      an = [],
      on = [],
      sn = [],
      hn = [],
      ln = (t, e) => (n) => {
        t.push(n), Rt || ((Rt = !0), e && 4 & zt.$flags$ ? un(wn) : zt.raf(wn));
      },
      cn = (t) => {
        for (var e = 0; e < t.length; e++)
          try {
            t[e](performance.now());
          } catch (t) {
            Ye(t);
          }
        t.length = 0;
      },
      dn = (t, e) => {
        for (var n = 0, r = 0; n < t.length && (r = performance.now()) < e; )
          try {
            t[n++](r);
          } catch (t) {
            Ye(t);
          }
        n === t.length ? (t.length = 0) : 0 !== n && t.splice(0, n);
      },
      wn = () => {
        if ((gt && _t++, cn(on), gt)) {
          var t = 2 == (6 & zt.$flags$) ? performance.now() + 14 * Math.ceil(0.1 * _t) : 1 / 0;
          dn(sn, t),
            dn(hn, t),
            sn.length > 0 && (hn.push(...sn), (sn.length = 0)),
            (Rt = on.length + sn.length + hn.length > 0) ? zt.raf(wn) : (_t = 0);
        } else cn(sn), (Rt = on.length > 0) && zt.raf(wn);
      },
      un = (t) => {
        return Promise.resolve(e).then(t);
        var e;
      },
      pn = ln(sn, !0);
  },
  44: function (t, e) {
    var n;
    n = (function () {
      return this;
    })();
    try {
      n = n || new Function('return this')();
    } catch (t) {
      'object' == typeof window && (n = window);
    }
    t.exports = n;
  },
});
